import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import CaseService from "../../../../services/CaseService";
import BundleService from "../../../../services/BundleService"; // NEW
import COLORS from "../../../../assets/Colors";
import moment from "moment";
import { useSnackbar } from "notistack";
import useLoader from "../../../../hooks/useLoader";
import AlertDialog from "../../Alert";
import ViewKeywords from "../../../internal/DrawerTable/ViewExtract";
import DocTypeChange from "../../../internal/DocumentTypeChange/DocTypeChange";
import DocVisibilityTypeChange from "../../../internal/DocVisibilityTypeChange/index";
import LockIcon from "@material-ui/icons/Lock";
import GroupIcon from "@material-ui/icons/Group";
import HttpsLockOpen from "@material-ui/icons/LockOpen";
import PublicIcon from "@material-ui/icons/Public";
import { WhatsApp as WhatsAppIcon } from "@material-ui/icons";
import { Tooltip } from "@material-ui/core";
import WhatsAppDocNotificationModal from "./WhatsAppDocNotificationModal";
import AddDocument from "../../../internal/DrawerTable/AddDocument";
import DocumentViewer from "./DocViewer";
import { prefetchHandlers, prefetchPdf } from "./pdfDocumentCache";
import { Spinner } from "./TrailBundle";
import CreateTrailBundleModal from "./CreateTrialBundleModal";
import { pdfjs } from "react-pdf";
import { CoreBundle, Layers } from "./components/Icons";
import UploadDocumentsModal from "./UploadDocumentsModal";
import CombineBundleModal from "./CombineBundleModal";
import MoveDocumentModal from "./MoveDocumentModal";
import CreateSubFolderModal from "./CreateSubFolderModal";
import SubFolderContextMenu from "./SubFolderContextMenu";
import BundleContextMenu from "./BundleContextMenu";
import {
  buildRedactedPdf,
  getRedactions,
  hasRedactions,
  redactedFileName,
  uploadRedactedPdf,
} from "./redaction";
import {
  EmptyState,
  EmptyText,
  ClearSearchBtn,
  SBadge,
  SBadgeDot,
  SBadgeWrap,
  SPageRef,
  SearchHighlight,
  DataRow,
  SecondaryBtn,
  SectionBar,
  SfHeaderLeft,
  SfHeaderRight,
  SfName,
  Shell,
  SideVisibilityDot,
  Sidebar,
  SidebarRenameInput,
  SidebarSummary,
  SidebarSummaryItem,
  SourceDot,
  DateLine,
  DateText,
  DeleteIconBtn,
  WhatsAppIconBtn,
  DeleteSelectedBtn,
  DimText,
  DocDescMeta,
  DocDescRow,
  DocDescText,
  DocIconFrame,
  DocName,
  DocNameRow,
  DocRef,
  Checkbox,
  ChevronWrap,
  NavBadge,
  NavIconWrap,
  NavLabel,
  NavRow,
  NavSection,
  NoResultsBanner,
  PageBtn,
  PageChip,
  PageControls,
  PageIconBox,
  PageSub,
  PageTitle,
  PageTitleGroup,
  PaginationBar,
  PaginationInfo,
  PaginationRight,
  PerPageSelect,
  Pill,
  PrimaryBtn,
  MobileCardList,
  MobileDocBody,
  VisibilityControl,
  SubNavEmpty,
  BundleNavRow,
  BundleNavChevron,
  BundleNavContent,
  BundleNavIdChip,
  ViewerPane,
  MobileDocCard,
  MobileDocIconBox,
  MobileDocName,
  MobileDocMeta,
  Content,
  OwnerBadge,
  EmptyHint,
  EmptyIconBox,
  FilterPills,
  FilterLabel,
  FilterStrip,
  SubNav,
  BundleNavName,
  SubFolderNavList,
  AddSubFolderInline,
  SubFolderNavRow,
  SubFolderChevron,
  SubFolderNavContent,
  SubFolderPrefixChip,
  SubFolderName,
  TabNavList,
  TabLabel,
  TabLabelGroup,
  TabNavCount,
  TabNavEmpty,
  TabNavLabel,
  TabNavRow,
  TabSepInner,
  TabSepMeta,
  TabSeparatorTd,
  TableWrap,
  TimeLine,
  TopBar,
  TopLeft,
  BundleBlock,
  BundleHeader,
  BundleSearchBar,
  BundlesWrap,
  BundleHeaderLeft,
  RenameInput,
  BundleHeaderTop,
  BundleTitle,
  MetaDivider,
  VisibilityBadge,
  ViewportWrap,
  BundleMeta,
  BundleStat,
  BundleStats,
  BundleHeaderActions,
  AddSubFolderBtn,
  EmptyRowBlock,
  SubFolderBlock,
  SubFolderHeader,
  InnerTable,
  InnerTr,
  ColTh,
  EmptyRowTd,
  EmptyRowUploadLink,
  QuickUploadBtn,
  RefChip,
  RowActions,
  MoveBtn,
  MobileSfCard,
  MobileEmpty,
  MobileSfCards,
  MobileSfCardTop,
  MobileSfCardName,
  MobileSfCardMeta,
  Main,
  HamburgerBtn,
  BackBtn,
  Overlay,
  IcoChevronDown,
  IcoChevronLeft,
  IcoChevronRight,
  IcoFile,
  IcoFolder,
  IcoFolderPlus,
  IcoLayers,
  IcoLock,
  IcoMenu,
  IcoMove,
  IcoPlus,
  IcoSearch,
  IcoTrash,
  IcoUpload,
  IcoDownload,
  IcoX,
  BundleIdChip,
  SfLabel,
  DragHandle,
  SidebarToggleBtn,
  SidebarHeader,
  SidebarTitle,
  CollapsedSidebarBar,
} from "./styles";
import useUser from "../../../../hooks/useUser";
import JSZip from "jszip";

if (!pdfjs.GlobalWorkerOptions.workerSrc) {
  pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
}

const SidebarCollapseIcon = ({ size = 15, color = "currentColor", style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ display: "inline-block", verticalAlign: "middle", ...style }}
  >
    <rect width="18" height="18" x="3" y="3" rx="2" />
    <path d="M9 3v18" />
    <path d="m14 9-3 3 3 3" />
  </svg>
);

const SidebarExpandIcon = ({ size = 15, color = "currentColor", style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ display: "inline-block", verticalAlign: "middle", ...style }}
  >
    <rect width="18" height="18" x="3" y="3" rx="2" />
    <path d="M9 3v18" />
    <path d="m13 15 3-3-3-3" />
  </svg>
);

const IcoClock = ({ size = 14, color = "currentColor", style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ display: "inline-block", verticalAlign: "middle", ...style }}
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const G = {
  teal: COLORS.BTN_GREEN || "#00838C",
  tealLight: "#E6F4F5",
  tealMid: "#B2DDE0",
  tealDark: "#006870",
  tealGhost: "#F0FAFB",
  navy: COLORS.COLOR_DARK || "#293461",
  navyLight: "#3D4A82",
  slate800: "#1E293B",
  slate700: "#334155",
  slate600: "#475569",
  slate500: "#64748B",
  slate400: "#94A3B8",
  slate300: "#CBD5E1",
  slate200: COLORS.BORDER_GREY || "#E1E3EE",
  slate100: COLORS.TABLE_GREY_CELL || "#F4F6FF",
  slate50: "#F8FAFC",
  white: "#FFFFFF",
  red: COLORS.REMOVE_RED || "#FF3C3C",
  redDark: COLORS.LOGOUT_RED || "#D91B1B",
  redLight: "#FFF1F1",
  amber: "#F59E0B",
  amberLight: "#FFFBEB",
  emerald: "#10B981",
  emeraldLight: "#ECFDF5",
  indigo: "#4F46E5",
  indigoLight: "#EEF2FF",
  shadowSm: "0 1px 3px rgba(41,52,97,0.08), 0 1px 2px rgba(41,52,97,0.04)",
  shadowMd: "0 4px 12px rgba(41,52,97,0.10), 0 2px 4px rgba(41,52,97,0.06)",
  shadowLg: "0 10px 30px rgba(41,52,97,0.12), 0 4px 8px rgba(41,52,97,0.06)",
};

const SOURCE_CFG = {
  Claimant: {
    bg: "#FFFBEB",
    border: "#FDE68A",
    dot: "#F59E0B",
    text: "#92400E",
  },
  Respondent: {
    bg: "#EEF2FF",
    border: "#C7D2FE",
    dot: "#4F46E5",
    text: "#3730A3",
  },
  Neutral: {
    bg: "#ECFDF5",
    border: "#A7F3D0",
    dot: "#10B981",
    text: "#065F46",
  },
};

const VISIBILITY_OPTIONS = [
  { value: "all", mode: "all", label: "Share with All Parties" },
  {
    value: "others",
    mode: "neutral",
    label: "Share with Case Manager & Neutrals",
  },
  { value: "me", mode: "private", label: "Share with My Team" },
  { value: "strictMode", mode: "private", label: "Private" },
];

const getVisibilityLabel = (value) =>
  VISIBILITY_OPTIONS.find((item) => item.value === value)?.label || "Private";
const getVisibilityMode = (value) =>
  VISIBILITY_OPTIONS.find((item) => item.value === value)?.mode || "private";

const getExhibitId = (doc) => {
  if (!doc) return null;
  return (
    doc.exhibitId ||
    doc.exhibit_id ||
    doc.exhibitCode ||
    doc.exhibit_code ||
    doc.properties?.exhibitId ||
    doc.properties?.exhibit_id ||
    doc.properties?.exhibitNo ||
    doc.properties?.exhibit_no ||
    null
  );
};

const truncateDocName = (name, limit = 50) => {
  if (!name) return "";
  if (name.length <= limit) return name;
  return name.slice(0, limit) + "...";
};

const normalizeVisibility = (value) => value || "me";
const isStrictVisibility = (value) =>
  normalizeVisibility(value) === "strictMode";
const isPrivateVisibility = (value) => isStrictVisibility(value);
const isPrivateBundle = (bundle) => isPrivateVisibility(bundle?.visibilityType);
export const isPrivateAssignment = (assignment, subFolder, bundle) =>
  isPrivateVisibility(
    assignment?.visibilityType ||
      assignment?.subFolder?.visibilityType ||
      subFolder?.visibilityType ||
      bundle?.visibilityType,
  );

const assignmentKey = (a) =>
  a?.id ??
  a?.assignmentId ??
  `${a?.sourceDocId || ""}_${a?.tabNum}_${a?.pages || ""}`;

export const sourceChip = (group) => {
  switch (group) {
    case "Claimant":
      return {
        bg: "#EFF6FF",
        fg: "#1E40AF",
        dot: "#3B82F6",
        border: "#93C5FD",
      };
    case "Respondent":
      return {
        bg: "#FEF2F2",
        fg: "#991B1B",
        dot: "#EF4444",
        border: "#FCA5A5",
      };
    default:
      return {
        bg: G.slate100,
        fg: G.slate600,
        dot: G.slate400,
        border: G.slate200,
      };
  }
};

const SourceBadge = ({ source, pageRef }) => {
  const c = SOURCE_CFG[source] || {
    bg: G.slate100,
    border: G.slate200,
    dot: G.slate400,
    text: G.slate600,
  };
  return (
    <SBadgeWrap>
      <SBadge
        style={{
          background: c.bg,
          border: `1px solid ${c.border}`,
          color: c.text,
        }}
      >
        <SBadgeDot style={{ background: c.dot }} />
        {source}
      </SBadge>
      {pageRef && <SPageRef>{pageRef}</SPageRef>}
    </SBadgeWrap>
  );
};

const VisibilitySelect = ({ value, onChange, disabled }) => (
  <VisibilityControl
    value={value || "me"}
    onClick={(e) => e.stopPropagation()}
    onChange={(e) =>
      onChange(e.target.value, {
        mode: getVisibilityMode(e.target.value),
      })
    }
    disabled={disabled}
    title="Change visibility"
  >
    {VISIBILITY_OPTIONS.map((item) => (
      <option
        key={item.value}
        value={item.value}
        style={{ color: COLORS.COLOR_DARK }}
      >
        {item.label}
      </option>
    ))}
  </VisibilityControl>
);

const Highlight = ({ text = "", query = "" }) => {
  if (!query.trim()) return <>{text}</>;
  const regex = new RegExp(
    `(${query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`,
    "gi",
  );
  const parts = text.split(regex);
  return (
    <>
      {parts.map((p, i) =>
        regex.test(p) ? (
          <SearchHighlight key={i}>{p}</SearchHighlight>
        ) : (
          <React.Fragment key={i}>{p}</React.Fragment>
        ),
      )}
    </>
  );
};

const apiBundleToInternal = (apiBundle) => {
  if (!apiBundle) return null;

  const bundleTabs = apiBundle.bundleTabs || [];
  const bundleFolders = apiBundle.bundleFolders || [];
  const hasBundleFolders = bundleFolders.length > 0;

  const seenPrefixes = new Set();
  const uniqueBundleFolders = bundleFolders.filter((f) => {
    const key = String(f.prefix).trim();
    if (seenPrefixes.has(key)) return false;
    seenPrefixes.add(key);
    return true;
  });

  const tabsWithPrefix = bundleTabs.filter(
    (t) => t?.prefix != null && String(t.prefix).trim() !== "",
  );
  const tabsWithoutPrefix = bundleTabs.filter(
    (t) => t?.prefix == null || String(t.prefix).trim() === "",
  );

  let subFolders = [];

  if (hasBundleFolders) {
    subFolders = uniqueBundleFolders.map((folder) => {
      const matchingTab = tabsWithPrefix.find(
        (t) =>
          String(t.prefix) === String(folder.prefix) ||
          String(t.code) === String(folder.prefix),
      );
      return {
        code: folder.prefix,
        name: folder.subFolderName,
        isMainFolder: false,
        visibilityType:
          folder.visibilityType ||
          matchingTab?.visibilityType ||
          matchingTab?.assignments?.[0]?.visibilityType ||
          apiBundle.visibilityType ||
          "me",
        assignments: (matchingTab?.assignments || []).sort(
          (a, b) => Number(a.tabNum) - Number(b.tabNum),
        ),
      };
    });

    tabsWithPrefix.forEach((tab) => {
      const code = tab.prefix || tab.code;
      if (!code) return;
      const exists = subFolders.some((sf) => String(sf.code) === String(code));
      if (!exists) {
        subFolders.push({
          code,
          name: tab.name || `Folder ${code}`,
          isMainFolder: false,
          visibilityType:
            tab.visibilityType ||
            tab.assignments?.[0]?.visibilityType ||
            apiBundle.visibilityType ||
            "me",
          assignments: (tab.assignments || []).sort(
            (a, b) => Number(a.tabNum) - Number(b.tabNum),
          ),
        });
      }
    });

    if (tabsWithoutPrefix.length > 0) {
      const flatAssignments = tabsWithoutPrefix
        .flatMap((t) => t.assignments || [])
        .sort((a, b) => Number(a.tabNum) - Number(b.tabNum));

      if (flatAssignments.length > 0) {
        subFolders.push({
          code: "__flat__",
          name: "Without Sub-folder",
          isMainFolder: true,
          visibilityType:
            tabsWithoutPrefix[0]?.visibilityType ||
            tabsWithoutPrefix[0]?.assignments?.[0]?.visibilityType ||
            apiBundle.visibilityType ||
            "me",
          assignments: flatAssignments,
        });
      }
    }

    subFolders.sort((a, b) => {
      const aMin =
        a.assignments.length > 0
          ? Math.min(...a.assignments.map((x) => Number(x.tabNum)))
          : Infinity;
      const bMin =
        b.assignments.length > 0
          ? Math.min(...b.assignments.map((x) => Number(x.tabNum)))
          : Infinity;
      return aMin - bMin;
    });
  } else {
    const allAssignments = bundleTabs
      .flatMap((t) => t.assignments || [])
      .sort((a, b) => Number(a.tabNum) - Number(b.tabNum));

    subFolders = [
      {
        code: "__main__",
        name: apiBundle.name || "Main Bundle",
        isMainFolder: true,
        visibilityType:
          bundleTabs[0]?.visibilityType ||
          bundleTabs[0]?.assignments?.[0]?.visibilityType ||
          apiBundle.visibilityType ||
          "me",
        assignments: allAssignments,
      },
    ];
  }

  return {
    id: apiBundle.id,
    bundleCode: apiBundle.bundleCode,
    name: apiBundle.name,
    bundleType: apiBundle.bundleType,
    ownerRole: apiBundle.ownerRole,
    ownerId: apiBundle.ownerId,
    hearing: apiBundle.hearing,
    caseId: apiBundle.caseId,
    visibilityType: apiBundle.visibilityType || "me",
    totalPages: apiBundle.totalPages,
    createdAt: apiBundle.created_at,
    updatedAt: apiBundle.updated_at,
    hasBundleFolders,
    bundles: subFolders,
  };
};

const apiListToInternal = (list) =>
  (Array.isArray(list) ? list : []).map(apiBundleToInternal).filter(Boolean);

const toUrlSegment = (str) => {
  if (!str) return "";
  return String(str)
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^a-zA-Z0-9_-]/g, "")
    .replace(/^-+|-+$/g, "");
};

const matchSegment = (val1, val2) => {
  if (val1 == null || val2 == null) return false;
  const s1 = String(val1).trim().toLowerCase();
  const s2 = String(val2).trim().toLowerCase();
  if (s1 === s2) return true;
  const u1 = toUrlSegment(val1).toLowerCase();
  const u2 = toUrlSegment(val2).toLowerCase();
  return u1 === u2 && u1 !== "";
};

const getCaseBasePath = (caseId, resolutionKind) => {
  if (typeof window === "undefined") return "";
  const path = window.location.pathname || "";
  const kind = resolutionKind || "arbitration";
  const target = `/${kind}/${caseId}`;
  const idx = path.indexOf(target);
  if (idx !== -1) {
    return path.substring(0, idx + target.length);
  }
  return `/dashboard/case-manager/${kind}/${caseId}`;
};

const updateUrlSilently = (newUrl) => {
  if (typeof window !== "undefined" && window.location.pathname !== newUrl) {
    window.history.pushState({ path: newUrl }, "", newUrl);
  }
};

const CoreBundleView = ({
  onBack,
  onNavigate,
  initialSource = "All",
  initialSection = "core",
  id,
  caseDetails,
  viewOnly = false,
  isActionsDisabled,
  setTrigger,
}) => {
  const [activeSection, setActiveSection] = useState(initialSection);
  const [activeSource, setActiveSource] = useState(initialSource);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [totalDocs, setTotalDocs] = useState(0);
  const [lastPage, setLastPage] = useState(1);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showCreateSubFolderModal, setShowCreateSubFolderModal] =
    useState(false);
  const [createSubFolderForBundleId, setCreateSubFolderForBundleId] =
    useState(null);
  const [showCombineModal, setShowCombineModal] = useState(false);
  const [moveDocState, setMoveDocState] = useState(null);
  const [uploadDocState, setUploadDocState] = useState(null);
  const [viewKeywords, setViewKeywords] = useState({ state: false });
  const [modalVisibility, setModalVisibility] = useState({ state: false });
  const [whatsAppModal, setWhatsAppModal] = useState({
    state: false,
    doc: null,
  });

  const handleOpenWhatsAppModal = (doc) => {
    setWhatsAppModal({ state: true, doc });
  };
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertData, setAlertData] = useState({});
  const [openTabs, setOpenTabs] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [selectedRows, setSelectedRows] = useState({});
  const [selectedCoreRows, setSelectedCoreRows] = useState({});
  const [selectedDocsMetadata, setSelectedDocsMetadata] = useState({});
  const { activeDoc, setActiveDoc } = useLoader();
  const [viewerPhase, setViewerPhase] = useState("idle");
  const [compareViewActive, setCompareViewActive] = useState(false);
  const exitTimerRef = useRef(null);
  const ANIM_DURATION = 320;
  const [coreExpanded, setCoreExpanded] = useState(initialSection === "core");
  const [trialExpanded, setTrialExpanded] = useState(
    initialSection === "trial",
  );
  const [privateExpanded, setPrivateExpanded] = useState(
    initialSection === "private",
  );
  const [recentlyViewedExpanded, setRecentlyViewedExpanded] = useState(true);
  const [recentlyViewedDocs, setRecentlyViewedDocs] = useState(() => {
    try {
      if (id) {
        const saved = localStorage.getItem(`recentlyViewedDocs_${id}`);
        return saved ? JSON.parse(saved) : [];
      }
    } catch (e) {
      // safe fallback
    }
    return [];
  });

  useEffect(() => {
    if (!id) return;
    try {
      const saved = localStorage.getItem(`recentlyViewedDocs_${id}`);
      if (saved) {
        setRecentlyViewedDocs(JSON.parse(saved));
      } else {
        setRecentlyViewedDocs([]);
      }
    } catch (e) {
      // safe fallback
    }
  }, [id]);

  const getDocViewerKey = useCallback(
    (doc) =>
      [
        doc?.id,
        doc?.sourceDocId,
        doc?.bundlecode,
        doc?.bundleId,
        doc?.tabNum,
        doc?.s3url,
        doc?.name,
      ]
        .filter(
          (value) => value !== undefined && value !== null && value !== "",
        )
        .join("::"),
    [],
  );

  const addToRecentlyViewed = useCallback(
    (doc) => {
      if (!doc) return;
      const docName =
        doc.name || doc.userLabel || doc.docName || "Untitled Document";
      const key = getDocViewerKey(doc) || doc.id || docName;

      setRecentlyViewedDocs((prevList) => {
        const filtered = prevList.filter((item) => item.id !== key);
        const newItem = {
          id: key,
          name: docName,
          doc: doc,
          viewedAt: Date.now(),
        };
        const updated = [newItem, ...filtered].slice(0, 20);
        try {
          if (id) {
            localStorage.setItem(
              `recentlyViewedDocs_${id}`,
              JSON.stringify(updated),
            );
          }
        } catch (e) {
          console.error(
            "Failed to save recently viewed documents to localStorage",
            e,
          );
        }
        return updated;
      });
    },
    [id, getDocViewerKey],
  );
  const [bundleTreeExpanded, setBundleTreeExpanded] = useState({});
  const [subFolderExpanded, setSubFolderExpanded] = useState({});

  const [activeBundleId, setActiveBundleId] = useState(null);
  const [activeSubFolder, setActiveSubFolder] = useState(null);
  const [activeTabNum, setActiveTabNum] = useState(null);
  const [bundleSearch, setBundleSearch] = useState("");
  const [trialBundles, setTrialBundles] = useState([]);
  const [trialBundlesLoading, setTrialBundlesLoading] = useState(false);
  const [trialBundlesError, setTrialBundlesError] = useState(null);
  const { userObject } = useUser();
  const initialDocsFetchedRef = useRef(false);
  const initialBundlesFetchedRef = useRef(false);

  const { enqueueSnackbar } = useSnackbar();
  const { setLoader } = useLoader();

  const fetchAllBundles = useCallback(async () => {
    setTrialBundlesLoading(true);
    setTrialBundlesError(null);
    try {
      const res = await BundleService.getBundleDocuments(`?caseId=${id}`);
      const list = res?.data ?? res;
      setTrialBundles(apiListToInternal(list));
    } catch (err) {
      setTrialBundlesError("Failed to load trial bundles");
      enqueueSnackbar("Failed to load trial bundles", { variant: "error" });
    } finally {
      setTrialBundlesLoading(false);
      initialBundlesFetchedRef.current = true; // NEW
    }
  }, [id, enqueueSnackbar]);

  const fetchBundleByCode = useCallback(
    async (bundleCode) => {
      if (!bundleCode) return null;
      try {
        const res = await BundleService.getBundleDocuments(
          `?bundleCode=${bundleCode}&caseId=${id}`,
        );
        const raw = res?.data ?? res;
        const single = Array.isArray(raw) ? raw[0] : raw;
        const internal = apiBundleToInternal(single);
        if (!internal) return null;
        setTrialBundles((prev) => {
          const exists = prev.some((b) => b.id === internal.id);
          return exists
            ? prev.map((b) => (b.id === internal.id ? internal : b))
            : [...prev, internal];
        });
        return internal;
      } catch (err) {
        enqueueSnackbar("Failed to load bundle", { variant: "error" });
        return null;
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [enqueueSnackbar],
  );
  useEffect(() => {
    if (id) fetchAllBundles();
  }, [id, fetchAllBundles]);

  const [renamingBundleId, setRenamingBundleId] = useState(null);
  const [renameValue, setRenameValue] = useState("");
  const [renamingSfCode, setRenamingSfCode] = useState(null);
  const [renameSfValue, setRenameSfValue] = useState("");
  const [renamingSfBundleId, setRenamingSfBundleId] = useState(null);
  const [sidebarRenamingBundleId, setSidebarRenamingBundleId] = useState(null);
  const [sidebarRenameBundleValue, setSidebarRenameBundleValue] = useState("");
  const [sidebarRenamingSf, setSidebarRenamingSf] = useState(null);
  const [sidebarRenameSfValue, setSidebarRenameSfValue] = useState("");
  const sidebarBundleRenameRef = useRef(null);
  const sidebarSfRenameRef = useRef(null);

  // ── Drag-and-drop state ──────────────────────────────────────────────────
  // dragState: what document is currently being dragged
  const [dragState, setDragState] = useState(null);
  // dropTarget: { bundleId, sfCode } — which drop zone is actively hovered
  const [dropTarget, setDropTarget] = useState(null);

  useEffect(() => {
    if (sidebarRenamingBundleId) {
      setTimeout(() => sidebarBundleRenameRef.current?.focus(), 0);
    }
  }, [sidebarRenamingBundleId]);

  useEffect(() => {
    if (sidebarRenamingSf) {
      setTimeout(() => sidebarSfRenameRef.current?.focus(), 0);
    }
  }, [sidebarRenamingSf]);

  const openViewer = (doc) => {
    clearTimeout(exitTimerRef.current);
    if (doc) {
      addToRecentlyViewed(doc);
    }
    const docKey = getDocViewerKey(doc);
    const existingTab = openTabs.find((t) => getDocViewerKey(t) === docKey);
    if (!existingTab) {
      setOpenTabs((p) => [...p, doc]);
      setActiveDoc(doc);
    } else {
      setActiveDoc(existingTab);
    }
    setSelectedRows({});
    setSelectedCoreRows({});
    setSelectedDocsMetadata({});
    setViewerPhase("entering");
    requestAnimationFrame(() =>
      requestAnimationFrame(() => setViewerPhase("visible")),
    );
  };
  const closeViewer = () => {
    setViewerPhase("exiting");
    exitTimerRef.current = setTimeout(() => {
      setActiveDoc(null);
      setViewerPhase("idle");
    }, ANIM_DURATION);
  };
  useEffect(() => () => clearTimeout(exitTimerRef.current), []);

  const handleCombineBundle = async ({ bundleIds, name, bundleCode }) => {
    try {
      setLoader({ state: true, message: "Combining bundles..." });
      const res = await BundleService.combineBundles({
        bundleIds,
        name,
        caseId: id,
      });
      const combinedRaw = res?.data ?? res;
      const combined = apiBundleToInternal(combinedRaw);

      setTrialBundles((prev) => {
        const filtered = prev.filter((b) => !bundleIds.includes(b.id));
        return combined ? [...filtered, combined] : filtered;
      });

      if (combined) {
        setActiveBundleId(combined.id);
        setActiveSubFolder(null);
        setActiveTabNum(null);
      }
      setTrialExpanded(true);
      setActiveSection("trial");
      enqueueSnackbar("Bundles combined successfully", { variant: "success" });
      fetchAllBundles();
    } catch (err) {
      enqueueSnackbar(err?.message || "Failed to combine bundles", {
        variant: "error",
      });
      throw err;
    } finally {
      setLoader({ state: false });
    }
  };

  const canMoveAssignment = (assignment, bundle, subFolder) => {
    if (activeSection !== "private") return true;
    return isPrivateAssignment(assignment, subFolder, bundle);
  };
  const getNextTabNum = (bundleId, sfCode) => {
    const bundle = trialBundles.find((b) => String(b.id) === String(bundleId));
    const subFolder = (bundle?.bundles || []).find(
      (sf) => String(sf.code) === String(sfCode),
    );
    const tabNums = (subFolder?.assignments || []).map(
      (a) => Number(a.tabNum) || 0,
    );
    return tabNums.length ? Math.max(...tabNums) + 1 : 1;
  };

  const openMoveDoc = (assignment, bundleId, sfCode, bundle, subFolder) => {
    if (!canMoveAssignment(assignment, bundle, subFolder)) {
      enqueueSnackbar(
        "Only private documents can be moved in My Private Bundles.",
        {
          variant: "warning",
        },
      );
      return;
    }
    setMoveDocState({
      assignment,
      sourceBundleId: bundleId,
      sourceSfCode: sfCode,
    });
  };

  const openUploadDocs = (bundle, subFolder) => {
    if (!bundle || !subFolder) return;
    setUploadDocState({ bundle, subFolder });
  };

  // ── Drag-and-drop handlers ───────────────────────────────────────────────

  /**
   * Called when the user starts dragging a document row.
   * Stores everything needed to perform the move when dropped.
   */
  const handleDragStart = (e, bundle, sf, tg) => {
    const firstRow = tg?.rows?.[0];
    if (!firstRow) return;

    // Only case-manager owners can move their own documents
    if (
      bundle.ownerRole !== "caseManager" ||
      bundle.ownerId !== userObject?.id
    ) {
      e.preventDefault();
      return;
    }

    const payload = {
      bundleId: bundle.id,
      sfCode: sf.code,
      tabNum: tg.tabNum,
      assignment: firstRow,
      bundle,
      sf,
    };

    // Store on the drag event so the browser knows dragging is active
    e.dataTransfer.effectAllowed = "move";
    try {
      e.dataTransfer.setData(
        "application/json",
        JSON.stringify({
          bundleId: bundle.id,
          sfCode: sf.code,
          tabNum: tg.tabNum,
        }),
      );
    } catch (_) {
      // setData can fail in some environments — the state fallback is sufficient
    }

    setDragState(payload);
  };

  /**
   * Called repeatedly while a dragged item hovers over a sub-folder drop zone (header/sidebar).
   */
  const handleDragOver = (e, bundleId, sfCode) => {
    if (!dragState) return;

    // Prevent drop on the same source sub-folder if not hovering over a specific row
    if (
      String(dragState.bundleId) === String(bundleId) &&
      String(dragState.sfCode) === String(sfCode)
    ) {
      e.dataTransfer.dropEffect = "none";
      return;
    }

    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    setDropTarget({ bundleId, sfCode });
  };

  /**
   * Called repeatedly while a dragged item hovers over a specific document row.
   * Enables intra-subfolder reordering when hovering over another row in the same subfolder.
   */
  const handleDragOverRow = (e, bundleId, sfCode, targetTabNum) => {
    if (!dragState) return;

    if (
      String(dragState.bundleId) === String(bundleId) &&
      String(dragState.sfCode) === String(sfCode)
    ) {
      if (dragState.tabNum === targetTabNum) {
        e.dataTransfer.dropEffect = "none";
        return;
      }
      e.preventDefault();
      e.dataTransfer.dropEffect = "move";
      setDropTarget({ bundleId, sfCode, isReorder: true, targetTabNum });
      return;
    }

    // Cross-subfolder row hover: delegate to normal drag over
    handleDragOver(e, bundleId, sfCode);
  };

  /**
   * Called when the dragged item leaves a drop zone without dropping.
   */
  const handleDragLeave = (e) => {
    if (e.currentTarget.contains(e.relatedTarget)) return;
    setDropTarget(null);
  };

  /**
   * Called when the user releases the drag on a valid drop zone or row.
   */
  const handleDrop = async (e, bundleId, sfCode, targetTabNum = null) => {
    e.preventDefault();
    const ds = dragState;
    setDragState(null);
    setDropTarget(null);

    if (!ds) return;

    // Check if dropping inside the same source sub-folder
    if (
      String(ds.bundleId) === String(bundleId) &&
      String(ds.sfCode) === String(sfCode)
    ) {
      if (targetTabNum != null && ds.tabNum !== targetTabNum) {
        await handleReorderDocument({
          bundleId: ds.bundleId,
          sfCode: ds.sfCode,
          sourceTabNum: ds.tabNum,
          targetTabNum,
          assignment: ds.assignment,
        });
      }
      return;
    }

    try {
      await handleMoveDocument({
        assignment: ds.assignment,
        sourceBundleId: ds.bundleId,
        sourceSfCode: ds.sfCode,
        targetBundleId: bundleId,
        targetSfCode: sfCode,
      });
    } catch (_) {
      // handleMoveDocument already shows a snackbar error
    }
  };

  /**
   * Reorders document tabs within the same subfolder.
   */
  const handleReorderDocument = async ({
    bundleId,
    sfCode,
    sourceTabNum,
    targetTabNum,
    assignment,
  }) => {
    const prevBundles = trialBundles;
    setTrialBundles((prev) =>
      prev.map((b) => {
        if (String(b.id) !== String(bundleId)) return b;
        return {
          ...b,
          bundles: (b.bundles || []).map((sf) => {
            if (String(sf.code) !== String(sfCode)) return sf;
            const assignments = [...(sf.assignments || [])];

            const moving = assignments.filter(
              (a) => Number(a.tabNum) === Number(sourceTabNum),
            );
            const remaining = assignments.filter(
              (a) => Number(a.tabNum) !== Number(sourceTabNum),
            );

            const targetIdx = remaining.findIndex(
              (a) => Number(a.tabNum) === Number(targetTabNum),
            );

            let reordered;
            if (targetIdx !== -1) {
              reordered = [
                ...remaining.slice(0, targetIdx),
                ...moving,
                ...remaining.slice(targetIdx),
              ];
            } else {
              reordered = [...remaining, ...moving];
            }

            let currentTab = 1;
            let lastOldTab = null;
            const updatedAssignments = reordered.map((a) => {
              if (lastOldTab !== null && a.tabNum !== lastOldTab) {
                currentTab++;
              }
              lastOldTab = a.tabNum;
              return { ...a, tabNum: currentTab };
            });

            return { ...sf, assignments: updatedAssignments };
          }),
        };
      }),
    );

    try {
      setLoader({ state: true, message: "Reordering document..." });
      await BundleService.moveDocument({
        caseId: id,
        sourceBundleId: bundleId,
        sourceSfCode: sfCode,
        targetBundleId: bundleId,
        targetSfCode: sfCode,
        sourceDocId: assignment.sourceDocId,
        assignmentId: assignment.id || assignment.assignmentId,
        tabNum: sourceTabNum,
        targetTabNum: targetTabNum,
        pages: assignment.pages,
        userLabel: assignment.userLabel,
      });
      enqueueSnackbar("Document reordered", { variant: "success" });
    } catch (err) {
      setTrialBundles(prevBundles);
      enqueueSnackbar(err?.message || "Failed to reorder document", {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }

    const bundle = trialBundles.find((b) => String(b.id) === String(bundleId));
    if (bundle?.bundleCode) {
      fetchBundleByCode(bundle.bundleCode);
    }
  };

  /**
   * Called when drag ends (whether or not a drop occurred).
   * Ensures highlights are always cleared.
   */
  const handleDragEnd = () => {
    setDragState(null);
    setDropTarget(null);
  };

  const deleteBunleDocument = (
    id,
    code,
    sourceDocId,
    bundleCode,
    tabNum,
    isMainFolder,
  ) => {
    setAlertData({
      heading: "Delete Document",
      desc: `Delete document? This action cannot be undone.`,
      primaryBtnText: "Cancel",
      secondaryBtnText: "Delete",
      clickSecondarybtn: async () => {
        try {
          setLoader({ state: true, message: "Deleting bundle..." });
          const respose = await BundleService.delete_bundle(id, {
            prefix: code,
            sourceDocId,
            tabNum,
            isMainFolder,
          });
          if (respose) {
            enqueueSnackbar(respose?.message, {
              variant: "success",
            });
          }
        } catch (err) {
          enqueueSnackbar(err?.message || "Failed to delete bundle", {
            variant: "error",
          });
        } finally {
          setLoader({ state: false });
          fetchBundleByCode(bundleCode);
          setAlertOpen(false);
        }
      },
      clickPrimaryBtn: () => setAlertOpen(false),
    });
    setAlertOpen(true);
  };

  const deleteMultipleBundleDocuments = async (selectedKeys, bundleCode) => {
    setAlertData({
      heading: "Delete Selected Documents",
      desc: `Delete ${selectedKeys.length} selected document(s) from this bundle? This action cannot be undone.`,
      primaryBtnText: "Cancel",
      secondaryBtnText: "Delete",
      clickSecondarybtn: async () => {
        try {
          setLoader({ state: true, message: "Deleting documents..." });

          // 1. Map all selected keys to their items using the current state
          const itemsToDelete = [];
          for (const key of selectedKeys) {
            const parts = key.split(":");
            const bundleId = parts[0];
            const sfCode = parts[1];
            const tabNum = Number(parts[2]);

            const currentBundle = trialBundles.find(
              (b) => String(b.id) === String(bundleId),
            );
            if (!currentBundle) continue;
            const subFolder = (currentBundle.bundles || []).find(
              (s) => s.code === sfCode,
            );
            if (!subFolder) continue;

            const tg = getSubFolderTabGroups(subFolder).find(
              (g) => g.tabNum === tabNum,
            );
            const firstRow = tg?.rows?.[0];
            if (!firstRow) continue;

            itemsToDelete.push({
              bundleId,
              sfCode,
              sourceDocId: firstRow.sourceDocId,
              tabNum,
              isMainFolder: subFolder.isMainFolder,
            });
          }

          // 2. Sort items in descending order of tabNum so deleting doesn't shift remaining tabNums in the loop
          itemsToDelete.sort((a, b) => b.tabNum - a.tabNum);

          // 3. Sequentially delete each document (extremely fast, no intermediate backend requests!)
          for (const item of itemsToDelete) {
            await BundleService.delete_bundle(item.bundleId, {
              prefix: item.sfCode,
              sourceDocId: item.sourceDocId,
              tabNum: item.tabNum,
              isMainFolder: item.isMainFolder,
            });
          }

          setSelectedRows((prev) => {
            const copy = { ...prev };
            selectedKeys.forEach((k) => {
              delete copy[k];
            });
            return copy;
          });

          enqueueSnackbar("Selected documents deleted successfully", {
            variant: "success",
          });
        } catch (err) {
          enqueueSnackbar(err?.message || "Failed to delete some documents", {
            variant: "error",
          });
        } finally {
          setLoader({ state: false });
          fetchBundleByCode(bundleCode);
          setAlertOpen(false);
        }
      },
      clickPrimaryBtn: () => setAlertOpen(false),
    });
    setAlertOpen(true);
  };

  const handleMoveDocument = async ({
    assignment,
    sourceBundleId,
    sourceSfCode,
    targetBundleId,
    targetSfCode,
  }) => {
    if (activeSection === "private" && !isPrivateAssignment(assignment)) {
      throw new Error(
        "Only private documents can be moved inside My Private Bundles.",
      );
    }

    const movingKey = assignmentKey(assignment);
    const prevBundles = trialBundles;

    const targetTabNum = getNextTabNum(targetBundleId, targetSfCode);

    setTrialBundles((p) =>
      p.map((b) => {
        if (String(sourceBundleId) === String(targetBundleId)) {
          if (String(b.id) === String(sourceBundleId)) {
            return {
              ...b,
              bundles: (b.bundles || []).map((sf) => {
                if (String(sf.code) === String(sourceSfCode)) {
                  return {
                    ...sf,
                    assignments: (sf.assignments || []).filter(
                      (a) => assignmentKey(a) !== movingKey,
                    ),
                  };
                }
                if (String(sf.code) === String(targetSfCode)) {
                  return {
                    ...sf,
                    assignments: [
                      ...(sf.assignments || []),
                      { ...assignment, tabNum: targetTabNum },
                    ],
                  };
                }
                return sf;
              }),
            };
          }
        } else {
          if (String(b.id) === String(sourceBundleId)) {
            return {
              ...b,
              bundles: (b.bundles || []).map((sf) =>
                sf.code !== sourceSfCode
                  ? sf
                  : {
                      ...sf,
                      assignments: (sf.assignments || []).filter(
                        (a) => assignmentKey(a) !== movingKey,
                      ),
                    },
              ),
            };
          }
          if (String(b.id) === String(targetBundleId)) {
            return {
              ...b,
              bundles: (b.bundles || []).map((sf) =>
                sf.code !== targetSfCode
                  ? sf
                  : {
                      ...sf,
                      assignments: [
                        ...(sf.assignments || []),
                        { ...assignment, tabNum: targetTabNum },
                      ],
                    },
              ),
            };
          }
        }
        return b;
      }),
    );

    try {
      setLoader({ state: true, message: "Moving document..." });
      await BundleService.moveDocument({
        caseId: id,
        sourceBundleId,
        sourceSfCode,
        targetBundleId,
        targetSfCode,
        sourceDocId: assignment.sourceDocId,
        assignmentId: assignment.id || assignment.assignmentId,
        tabNum: assignment.tabNum,
        targetTabNum,
        pages: assignment.pages,
        userLabel: assignment.userLabel,
      });
      enqueueSnackbar("Document moved", { variant: "success" });
    } catch (err) {
      setTrialBundles(prevBundles);
      enqueueSnackbar(err?.message || "Failed to move document", {
        variant: "error",
      });
      setMoveDocState(null);
      throw err;
    } finally {
      setLoader({ state: false });
    }
    const sourceBundle = trialBundles.find((b) => b.id === sourceBundleId);
    const targetBundle = trialBundles.find((b) => b.id === targetBundleId);
    if (sourceBundle?.bundleCode) fetchBundleByCode(sourceBundle.bundleCode);
    if (
      targetBundle?.bundleCode &&
      targetBundle.bundleCode !== sourceBundle?.bundleCode
    ) {
      fetchBundleByCode(targetBundle.bundleCode);
    }

    setMoveDocState(null);
  };

  const handleUploadDocuments = async ({
    bundleId,
    sfCode,
    subFolderName,
    isMainFolder,
    items,
  }) => {
    const bundle = trialBundles.find((b) => b.id === bundleId);
    let subFolder;

    if (sfCode === "__main__" || isMainFolder) {
      subFolder = bundle?.bundles?.find((s) => s.code === "__main__") || {
        assignments: [],
        visibilityType: bundle?.visibilityType,
      };
    } else {
      subFolder = (bundle?.bundles || []).find((s) => s.code === sfCode);
      if (!bundle || !subFolder) {
        throw new Error("Could not find the destination sub-folder.");
      }
    }

    const allBundleAssignments = (bundle?.bundles || []).flatMap(
      (sf) => sf.assignments || [],
    );

    const existingTabNums = allBundleAssignments.map(
      (a) => Number(a.tabNum) || 0,
    );
    let nextTabNum = existingTabNums.length
      ? Math.max(...existingTabNums) + 1
      : 1;

    const provisionalAssignments = items.assignments.map((item) => ({
      tabNum: nextTabNum++,
      userLabel: item.userLabel,
      pages: item.pages,
      sourceDocId: item.sourceDocId,
      source: item.source,
      fileUrl: item.fileUrl,
      visibilityType: subFolder.visibilityType || bundle.visibilityType,
    }));

    setTrialBundles((p) =>
      p.map((b) =>
        b.id !== bundleId
          ? b
          : {
              ...b,
              bundles: (b.bundles || []).map((sf) =>
                sf.code !== (sfCode === "__main__" ? "__main__" : sfCode)
                  ? sf
                  : {
                      ...sf,
                      assignments: [
                        ...(sf.assignments || []),
                        ...provisionalAssignments,
                      ],
                    },
              ),
            },
      ),
    );

    try {
      setLoader({ state: true, message: "Uploading files to bundle..." });

      const uploadPayload = {
        bundleId: items.bundleId,
        caseId: id,
        bundleConfigs: provisionalAssignments.map((item) => ({
          sourceDocId: item.sourceDocId,
          userLabel: item.userLabel,
          pages: item.pages,
          tabNum: item.tabNum,
          fileUrl: item?.fileUrl,
        })),
        isMainFolder: sfCode === "__main__" || isMainFolder === true,
      };

      if (sfCode !== "__main__" && !isMainFolder) {
        uploadPayload.prefix = sfCode;
        uploadPayload.subFolderName = subFolderName;
      }

      await BundleService.uploadDocumentsToBundle(uploadPayload);

      enqueueSnackbar(
        `${items.assignments.length} document${
          items.assignments.length !== 1 ? "s" : ""
        } added to ${sfCode === "__main__" ? "Main Folder" : sfCode}`,
        { variant: "success" },
      );
    } catch (err) {
      enqueueSnackbar(err?.message || "Failed to upload files to folder", {
        variant: "error",
      });
      throw err;
    } finally {
      setLoader({ state: false });
      fetchBundleByCode(bundle.bundleCode);
    }
  };

  const handleBundleVisibilityChange = async (
    bundleId,
    visibilityType,
    meta = {},
  ) => {
    const prevBundles = trialBundles;
    setTrialBundles((p) =>
      p.map((b) =>
        b.id === bundleId
          ? {
              ...b,
              visibilityType: visibilityType,
              mode: meta.mode || getVisibilityMode(visibilityType),
            }
          : b,
      ),
    );
    try {
      setLoader({ state: true, message: "Updating visibility..." });
      await BundleService.update_bundle(bundleId, {
        visibilityType,
        mode: meta.mode || getVisibilityMode(visibilityType),
      });
      enqueueSnackbar("Bundle visibility updated", { variant: "success" });
      fetchAllBundles();
    } catch (err) {
      setTrialBundles(prevBundles);
      enqueueSnackbar(err?.message || "Failed to update visibility", {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  };

  const handleBundleCreated = (bundleData) => {
    if (!bundleData) return;
    const internal = bundleData.bundles
      ? bundleData
      : apiBundleToInternal(bundleData);

    setTrialBundles((prev) =>
      prev.find((b) => b.id === internal.id) ? prev : [...prev, internal],
    );
    setTrialExpanded(true);
    setActiveSection("trial");
    setActiveBundleId(internal.id);
    setActiveSubFolder(null);
    setActiveTabNum(null);
    setSidebarOpen(false);
    fetchAllBundles();
  };

  const handleDeleteBundle = (bundle) => {
    setAlertData({
      heading: "Delete Bundle",
      desc: `Delete "${bundle.name}"? This action cannot be undone.`,
      primaryBtnText: "Cancel",
      secondaryBtnText: "Delete",
      clickSecondarybtn: async () => {
        try {
          setLoader({ state: true, message: "Deleting bundle..." });
          await BundleService.delete_bundle(bundle.id);
          setTrialBundles((p) => p.filter((b) => b.id !== bundle.id));
          if (activeBundleId === bundle.id) {
            setActiveBundleId(null);
            setActiveSubFolder(null);
            setActiveTabNum(null);
          }
          enqueueSnackbar("Bundle deleted", { variant: "success" });
        } catch (err) {
          enqueueSnackbar(err?.message || "Failed to delete bundle", {
            variant: "error",
          });
        } finally {
          setLoader({ state: false });
          setAlertOpen(false);
        }
      },
      clickPrimaryBtn: () => setAlertOpen(false),
    });
    setAlertOpen(true);
  };

  const handleRenameBundle = (bundleId) => {
    const b = trialBundles.find((b) => b.id === bundleId);
    if (b) {
      setRenamingBundleId(bundleId);
      setRenameValue(b.name);
    }
  };

  const commitRename = async (bundleId) => {
    const newName = renameValue.trim();
    const prevBundles = trialBundles;
    if (!newName) {
      setRenamingBundleId(null);
      setRenameValue("");
      return;
    }
    setTrialBundles((p) =>
      p.map((b) => (b.id === bundleId ? { ...b, name: newName } : b)),
    );
    setRenamingBundleId(null);
    setRenameValue("");
    try {
      await BundleService.update_bundle(bundleId, { name: newName });
      enqueueSnackbar("Bundle renamed", { variant: "success" });
    } catch (err) {
      setTrialBundles(prevBundles); // revert on failure
      enqueueSnackbar(err?.message || "Failed to rename bundle", {
        variant: "error",
      });
    }
  };

  const handleMoveBundleUp = (i) => {
    if (i === 0) return;
    setTrialBundles((p) => {
      const a = [...p];
      [a[i - 1], a[i]] = [a[i], a[i - 1]];
      return a;
    });
  };
  const handleMoveBundleDown = (i) => {
    setTrialBundles((p) => {
      if (i >= p.length - 1) return p;
      const a = [...p];
      [a[i], a[i + 1]] = [a[i + 1], a[i]];
      return a;
    });
  };

  const handleOpenCreateSubFolder = (bundleId) => {
    setCreateSubFolderForBundleId(bundleId);
    setShowCreateSubFolderModal(true);
  };

  const handleSubFolderCreated = async ({ name, code }) => {
    const bundleId = createSubFolderForBundleId;
    if (!bundleId) return;

    const exists = trialBundles
      .find((b) => b.id === bundleId)
      ?.bundles?.some((sf) => sf.code === code);
    if (exists) return;

    setTrialBundles((p) =>
      p.map((b) =>
        b.id !== bundleId
          ? b
          : {
              ...b,
              bundles: [...(b.bundles || []), { name, code, assignments: [] }],
            },
      ),
    );
    setBundleTreeExpanded((p) => ({ ...p, [bundleId]: true }));

    try {
      await BundleService.update_bundle(bundleId, {
        prefix: code,
        subFolderName: name,
        isNew: true,
      });
      enqueueSnackbar("Sub-folder created", { variant: "success" });
    } catch (err) {
      enqueueSnackbar(err?.message || "Failed to create sub-folder", {
        variant: "error",
      });
      fetchAllBundles();
    }
  };

  const handleDeleteSubFolder = (bundleId, sfCode) => {
    setAlertData({
      heading: "Delete Sub-folder",
      desc: `Delete sub-folder "${sfCode}"? All documents inside will be removed.`,
      primaryBtnText: "Cancel",
      secondaryBtnText: "Delete",
      clickSecondarybtn: async () => {
        try {
          setLoader({ state: true, message: "Deleting sub-folder..." });
          await BundleService.delete_bundle(bundleId, { prefix: sfCode });
          setTrialBundles((p) =>
            p.map((b) =>
              b.id !== bundleId
                ? b
                : {
                    ...b,
                    bundles: (b.bundles || []).filter(
                      (sf) => sf.code !== sfCode,
                    ),
                  },
            ),
          );
          if (activeSubFolder === sfCode) {
            setActiveSubFolder(null);
            setActiveTabNum(null);
          }
          enqueueSnackbar("Sub-folder deleted", { variant: "success" });
        } catch (err) {
          enqueueSnackbar(err?.message || "Failed to delete sub-folder", {
            variant: "error",
          });
        } finally {
          setLoader({ state: false });
          setAlertOpen(false);
        }
      },
      clickPrimaryBtn: () => setAlertOpen(false),
    });
    setAlertOpen(true);
  };

  const handleRenameSubFolder = (bundleId, sfCode) => {
    const b = trialBundles.find((b) => b.id === bundleId);
    const sf = (b?.bundles || []).find((s) => s.code === sfCode);
    if (sf) {
      setRenamingSfBundleId(bundleId);
      setRenamingSfCode(sfCode);
      setRenameSfValue(sf.name);
    }
  };

  const commitRenameSf = async (bundleId, sfCode) => {
    const newName = renameSfValue.trim();
    const prevBundles = trialBundles;
    if (!newName) {
      setRenamingSfBundleId(null);
      setRenamingSfCode(null);
      setRenameSfValue("");
      return;
    }
    setTrialBundles((p) =>
      p.map((b) =>
        b.id !== bundleId
          ? b
          : {
              ...b,
              bundles: (b.bundles || []).map((sf) =>
                sf.code === sfCode ? { ...sf, name: newName } : sf,
              ),
            },
      ),
    );
    setRenamingSfBundleId(null);
    setRenamingSfCode(null);
    setRenameSfValue("");
    try {
      await BundleService.update_bundle(bundleId, {
        prefix: sfCode,
        subFolderName: newName,
      });
      enqueueSnackbar("Sub-folder renamed", { variant: "success" });
    } catch (err) {
      setTrialBundles(prevBundles);
      enqueueSnackbar(err?.message || "Failed to rename sub-folder", {
        variant: "error",
      });
    }
  };

  const handleMoveSubFolderUp = (bundleId, i) => {
    setTrialBundles((p) =>
      p.map((b) => {
        if (b.id !== bundleId || i === 0) return b;
        const a = [...(b.bundles || [])];
        [a[i - 1], a[i]] = [a[i], a[i - 1]];
        return { ...b, bundles: a };
      }),
    );
  };
  const handleMoveSubFolderDown = (bundleId, i) => {
    setTrialBundles((p) =>
      p.map((b) => {
        if (b.id !== bundleId) return b;
        const a = [...(b.bundles || [])];
        if (i >= a.length - 1) return b;
        [a[i], a[i + 1]] = [a[i + 1], a[i]];
        return { ...b, bundles: a };
      }),
    );
  };

  const startSidebarBundleRename = (e, bundleId) => {
    e.preventDefault();
    e.stopPropagation();
    const b = trialBundles.find((b) => b.id === bundleId);
    if (!b) return;
    setBundleTreeExpanded((p) => ({ ...p, [bundleId]: true }));
    setSidebarRenamingSf(null);
    setSidebarRenamingBundleId(bundleId);
    setSidebarRenameBundleValue(b.name);
  };

  const commitSidebarBundleRename = async (bundleId) => {
    const val = sidebarRenameBundleValue.trim();
    const prevBundles = trialBundles;
    setSidebarRenamingBundleId(null);
    setSidebarRenameBundleValue("");
    if (!val) return;
    setTrialBundles((p) =>
      p.map((b) => (b.id === bundleId ? { ...b, name: val } : b)),
    );
    try {
      await BundleService.update_bundle(bundleId, { name: val });
      enqueueSnackbar("Bundle renamed", { variant: "success" });
    } catch (err) {
      setTrialBundles(prevBundles);
      enqueueSnackbar(err?.message || "Failed to rename bundle", {
        variant: "error",
      });
    }
  };

  const cancelSidebarBundleRename = () => {
    setSidebarRenamingBundleId(null);
    setSidebarRenameBundleValue("");
  };

  const startSidebarSfRename = (e, bundleId, sfCode) => {
    e.preventDefault();
    e.stopPropagation();
    const b = trialBundles.find((b) => b.id === bundleId);
    const sf = (b?.bundles || []).find((s) => s.code === sfCode);
    if (!sf) return;
    setSidebarRenamingBundleId(null);
    setSidebarRenamingSf({ bundleId, code: sfCode });
    setSidebarRenameSfValue(sf.name);
  };

  const commitSidebarSfRename = async (bundleId, sfCode) => {
    const val = sidebarRenameSfValue.trim();
    const prevBundles = trialBundles;
    setSidebarRenamingSf(null);
    setSidebarRenameSfValue("");
    if (!val) return;
    setTrialBundles((p) =>
      p.map((b) =>
        b.id !== bundleId
          ? b
          : {
              ...b,
              bundles: (b.bundles || []).map((sf) =>
                sf.code === sfCode ? { ...sf, name: val } : sf,
              ),
            },
      ),
    );
    try {
      await BundleService.update_bundle(bundleId, {
        prefix: sfCode,
        subFolderName: val,
      });
      enqueueSnackbar("Sub-folder renamed", { variant: "success" });
    } catch (err) {
      setTrialBundles(prevBundles);
      enqueueSnackbar(err?.message || "Failed to rename sub-folder", {
        variant: "error",
      });
    }
  };

  const cancelSidebarSfRename = () => {
    setSidebarRenamingSf(null);
    setSidebarRenameSfValue("");
  };

  const startSidebarMoveDoc = (e, bundleId, sfCode, tabGroup) => {
    e.preventDefault();
    e.stopPropagation();
    const firstRow = tabGroup?.rows?.[0];
    if (!firstRow) return;
    const bundle = trialBundles.find((b) => b.id === bundleId);
    const subFolder = (bundle?.bundles || []).find((sf) => sf.code === sfCode);
    openMoveDoc(firstRow, bundleId, sfCode, bundle, subFolder);
  };

  const handleOpenDoc = (doc) => openViewer(doc);
  const handleBack = () => closeViewer();
  const handleTabClick = (doc) => {
    setSelectedRows({});
    setSelectedCoreRows({});
    setSelectedDocsMetadata({});
    setActiveDoc(doc);
    setViewerPhase("visible");
  };
  const handleTabClose = (doc) => {
    const docKey = getDocViewerKey(doc);
    const rem = openTabs.filter((t) => getDocViewerKey(t) !== docKey);
    setOpenTabs(rem);
    if (getDocViewerKey(activeDoc) === docKey) {
      if (rem.length > 0) {
        setActiveDoc(rem[rem.length - 1]);
        setViewerPhase("visible");
      } else closeViewer();
    }
  };

  const handleOpenLinkedDoc = (targetDoc) => {
    clearTimeout(exitTimerRef.current);
    const docKey = getDocViewerKey(targetDoc);
    const existing = openTabs.find((t) => getDocViewerKey(t) === docKey);
    if (existing) {
      // already open — just switch to it with targetPage preserved
      const docWithPage = targetDoc.targetPage
        ? {
            ...existing,
            ...targetDoc,
            targetPage: targetDoc.targetPage,
            initialPage: targetDoc.targetPage,
            _hlNavTs: Date.now(),
          }
        : existing;
      setActiveDoc(docWithPage);
      setViewerPhase("visible");
      return;
    }
    // Insert immediately after the currently active tab
    const activeKey = getDocViewerKey(activeDoc);
    const idx = openTabs.findIndex((t) => getDocViewerKey(t) === activeKey);
    const next = [...openTabs];
    const cleanDoc = { ...targetDoc };
    delete cleanDoc.targetPage;
    delete cleanDoc.initialPage;
    delete cleanDoc._openInPageView;
    delete cleanDoc._hlNavTs;
    if (idx === -1) {
      next.push(cleanDoc);
    } else {
      next.splice(idx + 1, 0, cleanDoc);
    }
    setOpenTabs(next);
    setActiveDoc(targetDoc);
    setViewerPhase("visible");
  };

  const handleSectionSwitch = (section) => {
    setActiveSection(section);
    setSidebarOpen(false);
    if (section === "core") setCoreExpanded(true);
    else if (section === "trial") {
      setTrialExpanded(true);
      if (onNavigate) onNavigate("trailBundle");
    } else if (section === "private") {
      setPrivateExpanded(true);
      if (onNavigate) onNavigate("privateBundle");
    } else if (section === "transcripts") {
      if (onNavigate) onNavigate("transcripts");
    }
  };

  const fetchPageCount = async (url) => {
    if (!url) return null;
    try {
      const pdf = await pdfjs.getDocument({ url }).promise;
      return pdf.numPages;
    } catch {
      return null;
    }
  };

  const fetchDocuments = async (page = 1, perPage = 10, source = "All") => {
    setLoading(true);
    setError(null);
    let query = `?page=${page}&perPage=${perPage}`;
    if (source === "Claimant") query += "&claimantView=true";
    else if (source === "Respondent") query += "&respondentView=true";
    else if (source === "Neutral") query += "&commonView=true";
    try {
      const res = await CaseService.getcaseDocuments(id, query);
      if (!res?.data || !Array.isArray(res.data)) {
        setDocuments([]);
        setTotalDocs(0);
        return;
      }
      const transformed = res.data.map((doc) => ({
        ...doc,
        source: determineSource(doc),
        formattedDate: doc.created_at
          ? moment(doc.created_at).format("DD MMM YYYY")
          : "—",
        time: doc.created_at ? moment(doc.created_at).format("hh:mm A") : "",
        pageCount: null,
        fileUrl: doc.url?.url || null,
        ext: doc.url?.url?.split(".").pop()?.toLowerCase() || "pdf",
      }));
      setDocuments(transformed);
      setTotalDocs(res.total || 0);
      setLastPage(res.lastPage || 1);

      const needsProbe = transformed.filter(
        (d) => d.ext === "pdf" && d.fileUrl && d.pageCount === null,
      );
      if (!needsProbe.length) return;
      const CONCURRENCY = 5;
      const queue = [...needsProbe];
      const runBatch = async () => {
        while (queue.length > 0) {
          const batch = queue.splice(0, CONCURRENCY);
          const results = await Promise.all(
            batch.map(async (d) => ({
              id: d.id,
              pageCount: await fetchPageCount(d.fileUrl),
            })),
          );
          setDocuments((prev) =>
            prev.map((d) => {
              const r = results.find((r) => r.id === d.id);
              return r?.pageCount != null
                ? { ...d, pageCount: r.pageCount }
                : d;
            }),
          );
        }
      };
      runBatch();
    } catch (err) {
      setError("Failed to load documents");
      setDocuments([]);
      setTotalDocs(0);
    } finally {
      setLoading(false);
      initialDocsFetchedRef.current = true;
    }
  };

  const handleDocVisibilityUpdated = useCallback(
    (updatedDoc, newVisibility) => {
      const updatedKey = getDocViewerKey(updatedDoc);

      setActiveDoc((prev) =>
        prev && getDocViewerKey(prev) === updatedKey
          ? { ...prev, visibilityType: newVisibility }
          : prev,
      );

      setOpenTabs((prev) =>
        prev.map((t) =>
          getDocViewerKey(t) === updatedKey
            ? { ...t, visibilityType: newVisibility }
            : t,
        ),
      );

      if (!updatedDoc.bundle) {
        setDocuments((prev) =>
          prev.map((d) =>
            d.id === updatedDoc.id
              ? { ...d, visibilityType: newVisibility }
              : d,
          ),
        );
      }
    },
    [getDocViewerKey], // eslint-disable-line
  );

  const determineSource = (doc) => {
    if (doc.ownerType === "claimant" || doc.claimantView) return "Claimant";
    if (doc.ownerType === "respondent" || doc.respondentView)
      return "Respondent";
    return "Neutral";
  };

  useEffect(() => {
    if (activeSection) fetchDocuments(currentPage, itemsPerPage, activeSource);
  }, [currentPage, itemsPerPage, activeSource, id, activeSection]); // eslint-disable-line

  const handleSourceChange = (source) => {
    setActiveSource(source);
    setCurrentPage(1);
  };
  const handlePageChange = (page) => {
    if (page >= 1 && page <= lastPage) setCurrentPage(page);
  };
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleDelete = async (doc) => {
    try {
      setLoader({ state: true, message: "Deleting..." });
      await CaseService.deleteDocument(doc.entityId || id, doc.id);
      enqueueSnackbar("Document deleted", { variant: "success" });
      fetchDocuments(currentPage, itemsPerPage, activeSource);
    } catch {
      enqueueSnackbar("Failed to delete document", { variant: "error" });
    } finally {
      setLoader({ state: false });
      setAlertOpen(false);
    }
  };

  const openDeleteConfirm = (doc) => {
    setAlertData({
      heading: "Delete Document",
      desc: "Are you sure you want to delete this document? This cannot be undone.",
      primaryBtnText: "Cancel",
      secondaryBtnText: "Delete",
      clickSecondarybtn: () => handleDelete(doc),
      clickPrimaryBtn: () => setAlertOpen(false),
    });
    setAlertOpen(true);
  };

  const toggleRow = (key) => setSelectedRows((p) => ({ ...p, [key]: !p[key] }));

  const toggleCoreRow = (doc) => {
    setSelectedCoreRows((prev) => {
      const next = { ...prev };
      if (next[doc.id]) {
        delete next[doc.id];
        setSelectedDocsMetadata((prevMeta) => {
          const nextMeta = { ...prevMeta };
          delete nextMeta[doc.id];
          return nextMeta;
        });
      } else {
        next[doc.id] = true;
        setSelectedDocsMetadata((prevMeta) => ({
          ...prevMeta,
          [doc.id]: doc,
        }));
      }
      return next;
    });
  };

  const filteredDocuments = useMemo(() => {
    const q = bundleSearch.trim().toLowerCase();
    if (!q) return documents;
    return documents.filter(
      (doc) =>
        (doc.name || "").toLowerCase().includes(q) ||
        String(doc.documentNo ?? "")
          .toLowerCase()
          .includes(q),
    );
  }, [documents, bundleSearch]);

  const selectedCoreCount = useMemo(() => {
    return Object.keys(selectedCoreRows).filter((id) => selectedCoreRows[id])
      .length;
  }, [selectedCoreRows]);

  const isAllCoreSelected = useMemo(() => {
    if (filteredDocuments.length === 0) return false;
    return filteredDocuments.every((doc) => !!selectedCoreRows[doc.id]);
  }, [filteredDocuments, selectedCoreRows]);

  const isSomeCoreSelected = useMemo(() => {
    if (filteredDocuments.length === 0) return false;
    return (
      filteredDocuments.some((doc) => !!selectedCoreRows[doc.id]) &&
      !isAllCoreSelected
    );
  }, [filteredDocuments, selectedCoreRows, isAllCoreSelected]);

  const toggleAllCoreRows = async () => {
    const allSelected = filteredDocuments.every(
      (doc) => !!selectedCoreRows[doc.id],
    );

    if (allSelected) {
      setSelectedCoreRows({});
      setSelectedDocsMetadata({});
      return;
    }

    const next = { ...selectedCoreRows };
    const nextMeta = { ...selectedDocsMetadata };
    filteredDocuments.forEach((doc) => {
      next[doc.id] = true;
      nextMeta[doc.id] = doc;
    });

    if (totalDocs > filteredDocuments.length) {
      try {
        setLoader({
          state: true,
          message: "Selecting all files across pages...",
        });
        let query = `?page=1&perPage=${totalDocs}`;
        if (activeSource === "Claimant") query += "&claimantView=true";
        else if (activeSource === "Respondent") query += "&respondentView=true";
        else if (activeSource === "Neutral") query += "&commonView=true";

        const res = await CaseService.getcaseDocuments(id, query);
        if (res?.data && Array.isArray(res.data)) {
          res.data.forEach((d) => {
            const transformedDoc = {
              ...d,
              source:
                d.ownerType === "claimant" || d.claimantView
                  ? "Claimant"
                  : d.ownerType === "respondent" || d.respondentView
                    ? "Respondent"
                    : "Neutral",
              formattedDate: d.created_at
                ? moment(d.created_at).format("DD MMM YYYY")
                : "—",
              fileUrl: d.url?.url || null,
              ext: d.url?.url?.split(".").pop()?.toLowerCase() || "pdf",
            };
            next[transformedDoc.id] = true;
            nextMeta[transformedDoc.id] = transformedDoc;
          });
        }
      } catch (err) {
        enqueueSnackbar("Failed to select all documents across pages", {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
      }
    }

    setSelectedCoreRows(next);
    setSelectedDocsMetadata(nextMeta);
  };

  // Fetches a selected document, or builds its redacted copy when asked for
  // and the document has redactions.
  const getDownloadFile = async (doc, redacted) => {
    const url = doc.fileUrl;
    if (redacted && hasRedactions(url)) {
      const blob = await buildRedactedPdf(url, getRedactions(url));
      return {
        blob,
        baseName: `${sanitizeFileName(doc.name || `document_${doc.id}`)}_redacted`,
        ext: "pdf",
      };
    }
    const res = await fetch(url);
    if (!res.ok) throw new Error("Network response was not ok");
    return {
      blob: await res.blob(),
      baseName: sanitizeFileName(doc.name || `document_${doc.id}`),
      ext: url.split(".").pop()?.split("?")[0] || "pdf",
    };
  };

  const getSelectedCoreDocs = () =>
    Object.keys(selectedCoreRows)
      .filter((id) => selectedCoreRows[id])
      .map((id) => selectedDocsMetadata[id])
      .filter(Boolean);

  const handleDownloadCoreZip = () => {
    const docsToDownload = getSelectedCoreDocs();
    if (!docsToDownload.some((doc) => hasRedactions(doc.fileUrl))) {
      downloadCoreDocs(false);
      return;
    }
    const redactedCount = docsToDownload.filter((doc) =>
      hasRedactions(doc.fileUrl),
    ).length;
    setAlertData({
      heading: "Download Documents",
      desc:
        docsToDownload.length === 1
          ? "This document has redactions. Download the redacted copy or the original?"
          : `${redactedCount} of ${docsToDownload.length} selected documents have redactions. Download redacted copies or the originals?`,
      primaryBtnText: "Redacted",
      secondaryBtnText: "Original",
      clickPrimaryBtn: () => {
        setAlertOpen(false);
        downloadCoreDocs(true);
      },
      clickSecondarybtn: () => {
        setAlertOpen(false);
        downloadCoreDocs(false);
      },
      onDialogClose: () => setAlertOpen(false),
    });
    setAlertOpen(true);
  };

  const downloadCoreDocs = async (redacted) => {
    const docsToDownload = getSelectedCoreDocs();

    if (docsToDownload.length === 0) {
      enqueueSnackbar("No documents selected to download.", {
        variant: "warning",
      });
      return;
    }

    if (docsToDownload.length === 1) {
      const doc = docsToDownload[0];
      const url = doc.fileUrl;
      if (!url) {
        enqueueSnackbar("Document file URL is not available.", {
          variant: "error",
        });
        return;
      }
      try {
        setLoader({
          state: true,
          message: redacted ? "Preparing redacted copy..." : "Downloading file...",
        });
        const { blob, baseName, ext } = await getDownloadFile(doc, redacted);
        const fileName = `${baseName}.${ext}`;

        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
        enqueueSnackbar("Document downloaded", { variant: "success" });
      } catch (err) {
        enqueueSnackbar(err?.message || "Failed to download document", {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
      }
      return;
    }

    try {
      setLoader({
        state: true,
        message: redacted ? "Preparing redacted zip..." : "Preparing zip...",
      });
      const zip = new JSZip();
      const usedNames = new Set();

      await Promise.all(
        docsToDownload.map(async (doc) => {
          const url = doc.fileUrl;
          if (!url) return;

          try {
            const { blob, baseName, ext } = await getDownloadFile(
              doc,
              redacted,
            );
            let fileName = `${baseName}.${ext}`;

            let counter = 1;
            while (usedNames.has(fileName)) {
              fileName = `${baseName}_${counter}.${ext}`;
              counter += 1;
            }
            usedNames.add(fileName);

            zip.file(fileName, blob);
          } catch (e) {
            console.error("Failed to add file to zip:", e);
          }
        }),
      );

      const zipBlob = await zip.generateAsync({ type: "blob" });
      const zipUrl = URL.createObjectURL(zipBlob);
      const a = document.createElement("a");
      a.href = zipUrl;
      a.download = `core_bundle_documents.zip`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(zipUrl);

      enqueueSnackbar("Selected documents downloaded", { variant: "success" });
    } catch (err) {
      enqueueSnackbar(err?.message || "Failed to download documents", {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  };

  useEffect(() => {
    setSelectedCoreRows({});
    setSelectedDocsMetadata({});
  }, [currentPage, activeSource]);

  const getBundleSubFolders = (bundle) => bundle.bundles || [];
  const getVisibleSubFolderCount = (bundle) =>
    getBundleSubFolders(bundle).filter((sf) => !sf.isMainFolder).length;
  const getTabRef = (bundle, tabNum) =>
    `${bundle.bundleCode || bundle.id}/${tabNum}`;

  const parsePageCount = (pages) => {
    if (pages == null) return 0;
    const str = String(pages).trim();
    if (!str) return 0;
    return str.split(",").reduce((total, part) => {
      const segment = part.trim();
      if (!segment) return total;
      const rangeMatch = segment.match(/^(\d+)\s*[-–—]\s*(\d+)$/);
      if (rangeMatch) {
        const start = Number(rangeMatch[1]);
        const end = Number(rangeMatch[2]);
        if (!Number.isNaN(start) && !Number.isNaN(end) && end >= start)
          return total + (end - start + 1);
        return total;
      }
      const num = Number(segment);
      return Number.isNaN(num) ? total : total + 1;
    }, 0);
  };

  const getSubFolderTabGroups = (subFolder) => {
    const tabGroups = {};
    (subFolder.assignments || []).forEach((a) => {
      const k = `tab_${a.tabNum}`;
      const docName = a.userLabel ? a.userLabel.trim() : "";
      const pageCount = parsePageCount(a.pages);
      if (!tabGroups[k])
        tabGroups[k] = { tabNum: a.tabNum, docName, rows: [], totalPages: 0 };
      tabGroups[k].rows.push({ ...a, docName, pageCount, subFolder });
      tabGroups[k].totalPages += pageCount;
    });
    return Object.values(tabGroups).sort(
      (a, b) => Number(a.tabNum) - Number(b.tabNum),
    );
  };

  const privateBundles = useMemo(
    () => trialBundles.filter(isPrivateBundle),
    [trialBundles],
  );

  const activeBundleList =
    activeSection === "private" ? privateBundles : trialBundles;

  const filteredTrialBundles = useMemo(() => {
    const q = bundleSearch.trim().toLowerCase();
    if (!q) return activeBundleList;

    const endsWithSlash = q.endsWith("/");

    const buildRef = (bundleCodeStr, tabNum) =>
      `${bundleCodeStr}/${tabNum}`.trim().toLowerCase();

    const assignmentMatches = (bundleCodeStr, a) => {
      const ref = buildRef(bundleCodeStr, a.tabNum);

      if (endsWithSlash) {
        return ref.includes(q);
      }

      if (ref === q) return true;
      if (String(a.tabNum ?? "").toLowerCase() === q) return true;

      return false;
    };

    return activeBundleList
      .map((b) => {
        const bundleCodeStr = String(b.bundleCode ?? b.id ?? "")
          .trim()
          .toLowerCase();

        const bundleLevelMatch =
          (b.name || "").toLowerCase().includes(q) || bundleCodeStr.includes(q);

        if (bundleLevelMatch && !q.includes("/")) {
          return b;
        }

        const filteredSubFolders = (b.bundles || [])
          .map((sf) => {
            if (
              !q.includes("/") &&
              ((sf.name || "").toLowerCase().includes(q) ||
                (sf.code || "").toLowerCase().includes(q))
            ) {
              return sf;
            }

            const matchedAssignments = (sf.assignments || []).filter((a) =>
              assignmentMatches(bundleCodeStr, a),
            );

            if (matchedAssignments.length === 0) return null;
            return { ...sf, assignments: matchedAssignments };
          })
          .filter(Boolean);

        const matchedTopLevelAssignments = (b.assignments || []).filter((a) =>
          assignmentMatches(bundleCodeStr, a),
        );

        if (
          filteredSubFolders.length === 0 &&
          matchedTopLevelAssignments.length === 0
        ) {
          return null;
        }

        return {
          ...b,
          bundles: filteredSubFolders,
          assignments: matchedTopLevelAssignments,
        };
      })
      .filter(Boolean);
  }, [activeBundleList, bundleSearch]);

  useEffect(() => {
    setActiveSubFolder(null);
    setActiveTabNum(null);
  }, [bundleSearch]);

  const documentsSequence = useMemo(
    () => {
      if (activeSection === "core") {
        return documents.map((doc) => ({
          id: doc.id,
          name: doc.name,
          type: doc?.url?.uploadType,
          s3url: doc?.url?.url,
          visibilityType: doc?.visibilityType,
          keywords: doc.keywords,
          documentSummary: doc.documentSummary,
          documentNo: doc.documentNo || doc.document_no,
        }));
      }

      const seq = [];
      const bundlesList =
        activeSection === "private" ? privateBundles : trialBundles;

      bundlesList.forEach((bundle) => {
        const subFolders = bundle.bundles || [];
        subFolders.forEach((sf) => {
          const tabGroups = getSubFolderTabGroups(sf);
          tabGroups.forEach((tg) => {
            const firstRow = tg.rows?.[0] || {};
            seq.push({
              id: bundle.id,
              name: tg.docName || firstRow.userLabel || "Untitled Document",
              type: "pdf",
              s3url: firstRow?.bundleDocumentUrl || firstRow?.fileUrl,
              visibilityType: firstRow?.visibilityType,
              bundle: true,
              sourceDocId: firstRow.sourceDocId,
              bundlecode: sf.code,
              tabNum: tg.tabNum,
            });
          });
        });
      });

      (openTabs || []).forEach((tab) => {
        const tabKey = getDocViewerKey(tab);
        if (!seq.some((d) => getDocViewerKey(d) === tabKey)) {
          seq.push(tab);
        }
      });

      return seq;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      activeSection,
      documents,
      privateBundles,
      trialBundles,
      openTabs,
      getDocViewerKey,
    ],
  );

  const activeDocIndex = useMemo(() => {
    if (!activeDoc || !documentsSequence.length) return -1;
    const activeKey = getDocViewerKey(activeDoc);
    return documentsSequence.findIndex((d) => getDocViewerKey(d) === activeKey);
  }, [activeDoc, documentsSequence, getDocViewerKey]);

  const prevDocInSeq =
    activeDocIndex > 0 ? documentsSequence[activeDocIndex - 1] : null;
  const nextDocInSeq =
    activeDocIndex >= 0 && activeDocIndex < documentsSequence.length - 1
      ? documentsSequence[activeDocIndex + 1]
      : null;

  const nextPrefetchUrl = nextDocInSeq?.s3url;
  const prevPrefetchUrl = prevDocInSeq?.s3url;
  useEffect(() => {
    if (!activeDoc) return undefined;
    // Give the open document a head start before warming its neighbours.
    const timer = setTimeout(() => {
      prefetchPdf(nextPrefetchUrl);
      prefetchPdf(prevPrefetchUrl);
    }, 1500);
    return () => clearTimeout(timer);
  }, [activeDoc, nextPrefetchUrl, prevPrefetchUrl]);

  const toggleBundleTree = (bundleId) =>
    setBundleTreeExpanded((p) => ({ ...p, [bundleId]: !p[bundleId] }));
  const toggleSubFolderTree = (bundleId, subCode) => {
    const key = `${bundleId}_${subCode}`;
    setSubFolderExpanded((p) => ({ ...p, [key]: !p[key] }));
  };

  const handleNavSelectBundle = (bundleId, section = "trial") => {
    setActiveSection(section);
    setActiveBundleId(bundleId);
    setActiveSubFolder(null);
    setActiveTabNum(null);
    setBundleTreeExpanded((p) => ({ ...p, [bundleId]: true }));
    setSidebarOpen(false);
    if (onNavigate)
      onNavigate(section === "private" ? "privateBundle" : "trailBundle");

    const bundle = trialBundles.find((b) => b.id === bundleId);
    if (bundle?.bundleCode) fetchBundleByCode(bundle.bundleCode);
  };
  const handleNavSelectSubFolder = (bundleId, subCode) => {
    setActiveSection("trial");
    setActiveBundleId(bundleId);
    setActiveSubFolder(subCode);
    setActiveTabNum(null);
    setBundleTreeExpanded((p) => ({ ...p, [bundleId]: true }));
    setSubFolderExpanded((p) => ({ ...p, [`${bundleId}_${subCode}`]: true }));
    setSidebarOpen(false);
    if (onNavigate) onNavigate("trailBundle");

    const bundle = trialBundles.find((b) => b.id === bundleId);
    if (bundle?.bundleCode) fetchBundleByCode(bundle.bundleCode);
  };
  const handleNavSelectTab = (bundleId, subCode, tabNum) => {
    setActiveSection("trial");
    setActiveBundleId(bundleId);
    setActiveSubFolder(subCode);
    setActiveTabNum(tabNum);
    setSidebarOpen(false);
    if (onNavigate) onNavigate("trailBundle");
  };

  const parseAndApplyUrl = useCallback(
    (pathname, currentTrialBundles, currentDocs) => {
      if (!id) return;
      const basePath = getCaseBasePath(id, caseDetails?.resolutionKind);
      let sub = pathname.substring(basePath.length);
      if (sub.startsWith("/")) sub = sub.substring(1);
      if (!sub) return;

      const parts = sub.split("/").filter(Boolean);
      if (parts.length === 0) return;

      const bundleType = parts[0];

      if (bundleType === "core-bundle") {
        setActiveSection("core");
        setCoreExpanded(true);
        const tabNumParam = parts[1];
        if (tabNumParam && currentDocs && currentDocs.length > 0) {
          let targetDoc = currentDocs.find(
            (d) =>
              String(d.documentNo) === String(tabNumParam) ||
              String(d.document_no) === String(tabNumParam),
          );
          if (!targetDoc) {
            targetDoc = currentDocs.find(
              (d) => String(d.id) === String(tabNumParam),
            );
          }
          if (targetDoc) {
            const docObj = {
              id: targetDoc.id,
              name: targetDoc.name,
              type: targetDoc?.url?.uploadType,
              s3url: targetDoc?.url?.url,
              visibilityType: targetDoc?.visibilityType,
              keywords: targetDoc.keywords,
              documentSummary: targetDoc.documentSummary,
              documentNo: targetDoc.documentNo || targetDoc.document_no,
            };
            openViewer(docObj);
          }
        }
      } else if (bundleType === "trail-bundle") {
        setActiveSection("trial");
        setTrialExpanded(true);
        if (parts.length === 1) {
          setActiveBundleId(null);
          setActiveSubFolder(null);
          setActiveTabNum(null);
          return;
        }

        if (!currentTrialBundles || currentTrialBundles.length === 0) return;

        const bundleParam = parts[1];
        const matchedBundle = currentTrialBundles.find(
          (b) =>
            matchSegment(b.name, bundleParam) ||
            matchSegment(b.bundleCode, bundleParam) ||
            String(b.id) === String(bundleParam),
        );

        if (!matchedBundle) {
          let fallbackSf = null;
          let fallbackBundle = null;
          for (const b of currentTrialBundles) {
            const subFolders = getBundleSubFolders(b);
            const found = subFolders.find(
              (sf) =>
                matchSegment(sf.name, bundleParam) ||
                matchSegment(sf.code, bundleParam),
            );
            if (found) {
              fallbackSf = found;
              fallbackBundle = b;
              break;
            }
          }
          if (fallbackBundle) {
            setActiveBundleId(fallbackBundle.id);
            if (fallbackSf) setActiveSubFolder(fallbackSf.code);
          }
          return;
        }

        setActiveBundleId(matchedBundle.id);
        setBundleTreeExpanded((p) => ({ ...p, [matchedBundle.id]: true }));

        if (parts.length === 2) {
          setActiveSubFolder(null);
          setActiveTabNum(null);
          return;
        }

        const subFolders = getBundleSubFolders(matchedBundle);

        if (parts.length === 3) {
          const param = parts[2];
          const matchedSf = subFolders.find(
            (sf) =>
              matchSegment(sf.name, param) || matchSegment(sf.code, param),
          );

          if (matchedSf) {
            setActiveSubFolder(matchedSf.code);
            setActiveTabNum(null);
            setSubFolderExpanded((p) => ({
              ...p,
              [`${matchedBundle.id}_${matchedSf.code}`]: true,
            }));
          } else {
            const targetTabNum = param.split("-").pop();
            for (const sf of subFolders) {
              const tabGroups = getSubFolderTabGroups(sf);
              const tg = tabGroups.find(
                (g) =>
                  String(g.tabNum) === String(targetTabNum) ||
                  `${matchedBundle.bundleCode}-${g.tabNum}` === param ||
                  matchSegment(g.docName, param),
              );
              if (tg) {
                const firstRow = tg.rows?.[0] || {};
                const docObj = {
                  id: matchedBundle.id,
                  name: tg.docName || firstRow.userLabel || "Untitled Document",
                  type: "pdf",
                  s3url: firstRow?.bundleDocumentUrl || firstRow?.fileUrl,
                  visibilityType: firstRow?.visibilityType,
                  bundle: true,
                  sourceDocId: firstRow.sourceDocId,
                  bundlecode: sf.code,
                  tabNum: tg.tabNum,
                };
                setActiveSubFolder(sf.code);
                setSubFolderExpanded((p) => ({
                  ...p,
                  [`${matchedBundle.id}_${sf.code}`]: true,
                }));
                setActiveTabNum(tg.tabNum);
                openViewer(docObj);
                return;
              }
            }
          }
        } else if (parts.length >= 4) {
          const subfolderParam = parts[2];
          const tabRefParam = parts[3];
          const targetTabNum = tabRefParam.split("-").pop();

          const matchedSf = subFolders.find(
            (sf) =>
              matchSegment(sf.name, subfolderParam) ||
              matchSegment(sf.code, subfolderParam),
          );

          if (matchedSf) {
            setActiveSubFolder(matchedSf.code);
            setSubFolderExpanded((p) => ({
              ...p,
              [`${matchedBundle.id}_${matchedSf.code}`]: true,
            }));
            const tabGroups = getSubFolderTabGroups(matchedSf);
            const tg = tabGroups.find(
              (g) =>
                String(g.tabNum) === String(targetTabNum) ||
                `${matchedBundle.bundleCode}-${g.tabNum}` === tabRefParam ||
                matchSegment(g.docName, tabRefParam),
            );
            if (tg) {
              const firstRow = tg.rows?.[0] || {};
              const docObj = {
                id: matchedBundle.id,
                name: tg.docName || firstRow.userLabel || "Untitled Document",
                type: "pdf",
                s3url: firstRow?.bundleDocumentUrl || firstRow?.fileUrl,
                visibilityType: firstRow?.visibilityType,
                bundle: true,
                sourceDocId: firstRow.sourceDocId,
                bundlecode: matchedSf.code,
                tabNum: tg.tabNum,
              };
              setActiveTabNum(tg.tabNum);
              openViewer(docObj);
              return;
            }
          }
        }
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [id, caseDetails?.resolutionKind, openViewer],
  );

  const hasAppliedInitialUrlRef = useRef(false);

  const caseDetailsResolutionKind = caseDetails?.resolutionKind;

  useEffect(() => {
    if (hasAppliedInitialUrlRef.current) return;

    const basePath = getCaseBasePath(id, caseDetailsResolutionKind);
    let sub = window.location.pathname.substring(basePath.length);
    if (sub.startsWith("/")) sub = sub.substring(1);
    const bundleType = sub.split("/").filter(Boolean)[0];

    if (bundleType === "core-bundle") {
      if (!initialDocsFetchedRef.current) return;
    } else if (bundleType === "trail-bundle") {
      if (!initialBundlesFetchedRef.current) return;
    } else {
      if (!initialDocsFetchedRef.current && !initialBundlesFetchedRef.current)
        return;
    }

    hasAppliedInitialUrlRef.current = true;
    parseAndApplyUrl(window.location.pathname, trialBundles, documents);
  }, [
    trialBundles,
    documents,
    parseAndApplyUrl,
    id,
    caseDetailsResolutionKind,
  ]);

  useEffect(() => {
    const handlePopState = () => {
      parseAndApplyUrl(window.location.pathname, trialBundles, documents);
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [trialBundles, documents, parseAndApplyUrl]);

  useEffect(
    () => {
      if (!id || !hasAppliedInitialUrlRef.current) return;
      const basePath = getCaseBasePath(id, caseDetails?.resolutionKind);
      if (activeSection === "core") {
        if (activeDoc) {
          const tabNum =
            activeDoc.documentNo || activeDoc.document_no || activeDoc.id;
          updateUrlSilently(`${basePath}/core-bundle/${tabNum}`);
        } else {
          updateUrlSilently(`${basePath}/core-bundle`);
        }
      } else if (activeSection === "trial" || activeSection === "private") {
        if (activeDoc) {
          let foundBundle = trialBundles.find((b) => b.id === activeDoc.id);
          let foundSf = null;
          let foundTg = null;

          if (foundBundle) {
            for (const sf of foundBundle.bundles || []) {
              const tgs = getSubFolderTabGroups(sf);
              const tg = tgs.find((g) => {
                const firstRow = g.rows?.[0] || {};
                if (
                  activeDoc.tabNum != null &&
                  String(g.tabNum) === String(activeDoc.tabNum)
                ) {
                  return true;
                }
                return (
                  g.docName === activeDoc.name ||
                  firstRow.sourceDocId === activeDoc.sourceDocId
                );
              });
              if (tg) {
                foundSf = sf;
                foundTg = tg;
                break;
              }
            }
          }

          if (!foundBundle && activeBundleId) {
            foundBundle = trialBundles.find((b) => b.id === activeBundleId);
          }
          if (!foundSf && activeSubFolder && foundBundle) {
            foundSf = (foundBundle.bundles || []).find(
              (s) => s.code === activeSubFolder,
            );
          }

          const bundleNameSlug =
            toUrlSegment(foundBundle?.name) ||
            toUrlSegment(foundBundle?.bundleCode) ||
            "bundle";
          const bundleCode = foundBundle?.bundleCode || "TB";
          const tabNum =
            activeDoc.tabNum || foundTg?.tabNum || activeTabNum || 1;
          const tabRef = `${bundleCode}-${tabNum}`;

          if (foundSf && !foundSf.isMainFolder) {
            const sfSlug =
              toUrlSegment(foundSf.name) || toUrlSegment(foundSf.code);
            updateUrlSilently(
              `${basePath}/trail-bundle/${bundleNameSlug}/${sfSlug}/${tabRef}`,
            );
          } else {
            updateUrlSilently(
              `${basePath}/trail-bundle/${bundleNameSlug}/${tabRef}`,
            );
          }
        } else if (activeBundleId) {
          const bundle = trialBundles.find((b) => b.id === activeBundleId);
          const bundleNameSlug =
            toUrlSegment(bundle?.name) ||
            toUrlSegment(bundle?.bundleCode) ||
            "bundle";
          const sf = activeSubFolder
            ? (bundle?.bundles || []).find((s) => s.code === activeSubFolder)
            : null;
          if (sf && !sf.isMainFolder) {
            const sfSlug = toUrlSegment(sf.name) || toUrlSegment(sf.code);
            updateUrlSilently(
              `${basePath}/trail-bundle/${bundleNameSlug}/${sfSlug}`,
            );
          } else {
            updateUrlSilently(`${basePath}/trail-bundle/${bundleNameSlug}`);
          }
        } else {
          updateUrlSilently(`${basePath}/trail-bundle`);
        }
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      activeSection,
      activeDoc,
      activeBundleId,
      activeSubFolder,
      activeTabNum,
      trialBundles,
      documentsSequence,
      id,
      caseDetailsResolutionKind,
      getDocViewerKey,
    ],
  );

  const handleOpenBundleInTable = (bundle) => {
    setActiveBundleId(bundle.id);
    if (bundle?.bundleCode) fetchBundleByCode(bundle.bundleCode);
  };

  const sanitizeFileName = (name) =>
    (name || "file").replace(/[\\/:*?"<>|]/g, "_").trim();

  const handleDownloadBundle = async (
    bundleId,
    prefix = "",
    subFolderName = "",
  ) => {
    try {
      setLoader({ state: true, message: "Preparing download..." });
      const payload = {
        bundleId: bundleId || "",
      };
      if (prefix) {
        payload.prefix = prefix;
      }
      if (subFolderName) {
        payload.subFolderName = subFolderName;
      }
      const res = await BundleService.downloadBundle(payload);
      if (res?.fileUrl) {
        window.open(res?.fileUrl);
      }
    } catch (err) {
      enqueueSnackbar("An error occurred during download.", {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  };

  const sectionMeta = {
    core: {
      icon: <CoreBundle size={17} color={G.teal} />,
      title: "Core Bundle",
      placeholder: "Search documents…",
    },
    trial: {
      icon: <IcoLayers size={17} color={G.teal} />,
      title: "Trial Bundles",
      placeholder: "Search bundles…",
    },
    private: {
      icon: <IcoLock size={17} color={G.teal} />,
      title: "My Private Bundles",
      placeholder: "Search private bundles…",
    },
  };
  const meta = sectionMeta[activeSection] || sectionMeta.core;

  const getTrialViewTitle = () => {
    if (!activeBundleId)
      return activeSection === "private"
        ? "My Private Bundles"
        : "Trial Bundles";
    const b = trialBundles.find((b) => b.id === activeBundleId);
    if (!b)
      return activeSection === "private"
        ? "My Private Bundles"
        : "Trial Bundles";
    return activeSection === "private" ? "My Private Bundles" : "Trial Bundles";
  };

  const viewerMounted = viewerPhase !== "idle";

  const renderSidebar = () => (
    <>
      <NavSection>
        <NavRow
          $active={
            !activeDoc && activeSection === "core" && activeSource === "All"
          }
          onClick={() => {
            setCoreExpanded((v) => !v);
            setActiveSection("core");
            setActiveSource("All");
            setSidebarOpen(false);
            handleBack();
          }}
        >
          <ChevronWrap>
            {coreExpanded ? <IcoChevronDown /> : <IcoChevronRight />}
          </ChevronWrap>
          <NavIconWrap>
            <CoreBundle
              size={14}
              color={
                !activeDoc && activeSection === "core" ? G.teal : G.slate500
              }
            />
          </NavIconWrap>
          <NavLabel $active={!activeDoc && activeSection === "core"}>
            Core Bundle
          </NavLabel>
          <NavBadge $active={!activeDoc && activeSection === "core"}>
            {totalDocs}
          </NavBadge>
          {/* <NavAddBtn onClick={(e) => e.stopPropagation()}>
            <IcoPlus size={10} color={G.teal} />
          </NavAddBtn> */}
        </NavRow>

        {coreExpanded && (
          <SubNav $flat>
            <BundleNavRow
              $active={
                !activeDoc && activeSection === "core" && activeSource === "All"
              }
              style={{
                borderLeft: `3px solid ${
                  !activeDoc &&
                  activeSection === "core" &&
                  activeSource === "All"
                    ? G.teal
                    : G.slate200
                }`,
                marginLeft: 8,
                borderRadius: 0,
                background:
                  !activeDoc &&
                  activeSection === "core" &&
                  activeSource === "All"
                    ? G.tealLight
                    : "transparent",
              }}
            >
              <BundleNavContent
                onClick={() => {
                  setActiveSection("core");
                  handleSourceChange("All");
                  setSidebarOpen(false);
                  handleBack();
                }}
              >
                <IcoFile
                  size={12}
                  color={
                    !activeDoc &&
                    activeSection === "core" &&
                    activeSource === "All"
                      ? G.teal
                      : G.slate400
                  }
                />
                <BundleNavName
                  $active={
                    !activeDoc &&
                    activeSection === "core" &&
                    activeSource === "All"
                  }
                >
                  All Documents
                </BundleNavName>
              </BundleNavContent>
              <NavBadge
                $active={
                  !activeDoc &&
                  activeSection === "core" &&
                  activeSource === "All"
                }
              >
                {totalDocs}
              </NavBadge>
            </BundleNavRow>

            {["Claimant", "Respondent", "Neutral"].map((src) => {
              const isActive =
                !activeDoc && activeSection === "core" && activeSource === src;
              const dotColors = {
                Claimant: G.amber,
                Respondent: G.indigo,
                Neutral: G.emerald,
              };
              return (
                <BundleNavRow
                  key={src}
                  $active={isActive}
                  style={{
                    borderLeft: `3px solid ${isActive ? dotColors[src] : G.slate200}`,
                    marginLeft: 8,
                    borderRadius: 0,
                    paddingLeft: 20,
                    background: isActive
                      ? `${dotColors[src]}12`
                      : "transparent",
                  }}
                >
                  <BundleNavContent
                    onClick={() => {
                      setActiveSection("core");
                      handleSourceChange(src);
                      setSidebarOpen(false);
                      handleBack();
                    }}
                  >
                    <SideVisibilityDot
                      style={{
                        background: dotColors[src],
                        minWidth: 7,
                        minHeight: 7,
                      }}
                    />
                    <BundleNavName $active={isActive}>
                      {src} Documents
                    </BundleNavName>
                  </BundleNavContent>
                  {isActive && <NavBadge $active>{totalDocs}</NavBadge>}
                </BundleNavRow>
              );
            })}
          </SubNav>
        )}
      </NavSection>

      <NavSection>
        <NavRow
          $active={!activeDoc && activeSection === "trial" && !activeBundleId}
          onClick={() => {
            handleBack();
            setTrialExpanded((v) => !v);
            setActiveSection("trial");
            setActiveBundleId(null);
            setActiveSubFolder(null);
            setActiveTabNum(null);
            setSidebarOpen(false);
            if (onNavigate) {
              onNavigate("trailBundle");
              handleBack();
            }
          }}
        >
          <ChevronWrap>
            {trialExpanded ? <IcoChevronDown /> : <IcoChevronRight />}
          </ChevronWrap>
          <NavIconWrap>
            <IcoLayers
              size={14}
              color={
                !activeDoc && activeSection === "trial" && !activeBundleId
                  ? G.teal
                  : G.slate500
              }
            />
          </NavIconWrap>
          <NavLabel
            $active={!activeDoc && activeSection === "trial" && !activeBundleId}
          >
            Trial Bundles
          </NavLabel>
          <NavBadge
            $active={!activeDoc && activeSection === "trial" && !activeBundleId}
          >
            {trialBundles.length}
          </NavBadge>
          {/* <NavAddBtn
            onClick={(e) => {
              e.stopPropagation();
              setShowCreateModal(true);
              handleBack();
            }}
          >
            <IcoPlus size={10} color={G.teal} />
          </NavAddBtn> */}
        </NavRow>

        {trialExpanded && (
          <SubNav $flat>
            {trialBundlesLoading && <SubNavEmpty>Loading bundles…</SubNavEmpty>}
            {!trialBundlesLoading && trialBundlesError && (
              <SubNavEmpty style={{ color: G.red }}>
                {trialBundlesError}
              </SubNavEmpty>
            )}
            {!trialBundlesLoading &&
              !trialBundlesError &&
              trialBundles.length === 0 && (
                <SubNavEmpty>No bundles yet</SubNavEmpty>
              )}
            {trialBundles.map((bundle) => {
              const isBundleActive =
                activeSection === "trial" && activeBundleId === bundle.id;
              const isBundleOpen = !!bundleTreeExpanded[bundle.id];
              const subFolders = getBundleSubFolders(bundle);
              const visibleSubFolderCount = getVisibleSubFolderCount(bundle);
              const isRenamingThisBundle =
                sidebarRenamingBundleId === bundle.id;
              return (
                <div key={bundle.id}>
                  <BundleNavRow
                    $active={!activeDoc && isBundleActive && !activeSubFolder}
                    $isDragOver={
                      dropTarget &&
                      dropTarget.bundleId === bundle.id &&
                      dropTarget.sfCode ===
                        (bundle.hasBundleFolders ? "__flat__" : "__main__")
                    }
                    onDragOver={(e) =>
                      bundle.ownerRole === "caseManager" &&
                      bundle.ownerId === userObject?.id
                        ? handleDragOver(
                            e,
                            bundle.id,
                            bundle.hasBundleFolders ? "__flat__" : "__main__",
                          )
                        : null
                    }
                    onDragLeave={handleDragLeave}
                    onDrop={(e) =>
                      bundle.ownerRole === "caseManager" &&
                      bundle.ownerId === userObject?.id
                        ? handleDrop(
                            e,
                            bundle.id,
                            bundle.hasBundleFolders ? "__flat__" : "__main__",
                          )
                        : null
                    }
                    onContextMenu={(e) =>
                      bundle.ownerRole === "caseManager" &&
                      bundle.ownerId === userObject?.id
                        ? startSidebarBundleRename(e, bundle.id)
                        : {}
                    }
                  >
                    <BundleNavChevron
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleBundleTree(bundle.id);
                        if (!activeDoc) handleBack();
                      }}
                    >
                      {isBundleOpen ? (
                        <IcoChevronDown size={10} color={G.slate400} />
                      ) : (
                        <IcoChevronRight size={10} color={G.slate400} />
                      )}
                    </BundleNavChevron>

                    {isRenamingThisBundle ? (
                      <SidebarRenameInput
                        ref={sidebarBundleRenameRef}
                        value={sidebarRenameBundleValue}
                        onChange={(e) =>
                          setSidebarRenameBundleValue(e.target.value)
                        }
                        onClick={(e) => e.stopPropagation()}
                        onBlur={() => commitSidebarBundleRename(bundle.id)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter")
                            commitSidebarBundleRename(bundle.id);
                          if (e.key === "Escape") cancelSidebarBundleRename();
                        }}
                      />
                    ) : (
                      <BundleNavContent
                        onClick={() => {
                          if (activeDoc) {
                            toggleBundleTree(bundle.id);
                            return;
                          }
                          handleNavSelectBundle(bundle.id);
                          handleBack();
                        }}
                      >
                        <Layers
                          size={12}
                          color={
                            !activeDoc && isBundleActive && !activeSubFolder
                              ? G.teal
                              : G.slate400
                          }
                        />

                        <BundleNavName
                          $active={
                            !activeDoc && isBundleActive && !activeSubFolder
                          }
                        >
                          {bundle.name}
                        </BundleNavName>
                      </BundleNavContent>
                    )}
                    <SideVisibilityDot
                      $visibility={bundle.visibilityType || "me"}
                      title={getVisibilityLabel(bundle.visibilityType)}
                    />
                    <NavBadge
                      $active={!activeDoc && isBundleActive && !activeSubFolder}
                    >
                      {visibleSubFolderCount > 0
                        ? visibleSubFolderCount
                        : subFolders.reduce(
                            (sum, sf) => sum + getSubFolderTabGroups(sf).length,
                            0,
                          )}
                    </NavBadge>
                  </BundleNavRow>

                  {isBundleOpen && (
                    <SubFolderNavList>
                      {subFolders.map((sf) => {
                        const sfKey = `${bundle.id}_${sf.code}`;
                        const isSFActive =
                          isBundleActive && activeSubFolder === sf.code;
                        const isSFOpen = !!subFolderExpanded[sfKey];
                        const tabGroups = getSubFolderTabGroups(sf);
                        const isRenamingThisSf =
                          sidebarRenamingSf &&
                          sidebarRenamingSf.bundleId === bundle.id &&
                          sidebarRenamingSf.code === sf.code;

                        if (sf.isMainFolder) {
                          return (
                            <React.Fragment key={sf.code}>
                              {tabGroups.map((tg) => {
                                const firstRow = tg.rows?.[0] || {};
                                const docObj = {
                                  id: bundle.id,
                                  name:
                                    tg.docName ||
                                    firstRow.userLabel ||
                                    "Untitled Document",
                                  type: "pdf",
                                  s3url:
                                    firstRow?.bundleDocumentUrl ||
                                    firstRow?.fileUrl,
                                  visibilityType: firstRow?.visibilityType,
                                  bundle: true,
                                  sourceDocId: firstRow.sourceDocId,
                                  bundlecode: sf.code,
                                  tabNum: tg.tabNum,
                                };
                                const isTabActive = activeDoc
                                  ? getDocViewerKey(activeDoc) ===
                                    getDocViewerKey(docObj)
                                  : isBundleActive &&
                                    String(activeTabNum) === String(tg.tabNum);
                                return (
                                  <TabNavRow
                                    key={tg.tabNum}
                                    $active={isTabActive}
                                    {...prefetchHandlers(docObj.s3url)}
                                    onClick={() => {
                                      if (activeDoc) {
                                        handleOpenDoc(docObj);
                                        return;
                                      }
                                      handleNavSelectTab(
                                        bundle.id,
                                        sf.code,
                                        tg.tabNum,
                                      );
                                      handleBack();
                                    }}
                                    title={getTabRef(bundle, tg.tabNum)}
                                    style={{
                                      paddingLeft: 28,
                                      borderLeft: `3px solid ${isTabActive ? G.teal : G.slate200}`,
                                      marginLeft: 8,
                                      borderRadius: 0,
                                    }}
                                  >
                                    <IcoFile
                                      size={10}
                                      color={isTabActive ? G.teal : G.slate400}
                                    />
                                    <TabNavLabel $active={isTabActive}>
                                      {tg.docName || `Tab ${tg.tabNum}`}
                                    </TabNavLabel>
                                    <TabNavCount $active={isTabActive}>
                                      {tg.totalPages}p
                                    </TabNavCount>
                                  </TabNavRow>
                                );
                              })}
                            </React.Fragment>
                          );
                        }

                        return (
                          <div key={sf.code}>
                            <SubFolderNavRow
                              $active={
                                !activeDoc && isSFActive && activeTabNum == null
                              }
                              $isDragOver={
                                dropTarget &&
                                dropTarget.bundleId === bundle.id &&
                                dropTarget.sfCode === sf.code
                              }
                              onDragOver={(e) =>
                                bundle.ownerRole === "caseManager" &&
                                bundle.ownerId === userObject?.id
                                  ? handleDragOver(e, bundle.id, sf.code)
                                  : null
                              }
                              onDragLeave={handleDragLeave}
                              onDrop={(e) =>
                                bundle.ownerRole === "caseManager" &&
                                bundle.ownerId === userObject?.id
                                  ? handleDrop(e, bundle.id, sf.code)
                                  : null
                              }
                              onContextMenu={(e) =>
                                bundle.ownerRole === "caseManager" &&
                                bundle.ownerId === userObject?.id
                                  ? startSidebarSfRename(e, bundle.id, sf.code)
                                  : {}
                              }
                              style={{
                                borderLeft: `3px solid ${
                                  !activeDoc &&
                                  isSFActive &&
                                  activeTabNum == null
                                    ? G.teal
                                    : G.tealMid
                                }`,
                                marginLeft: 8,
                                borderRadius: 0,
                                background:
                                  !activeDoc &&
                                  isSFActive &&
                                  activeTabNum == null
                                    ? G.tealLight
                                    : "transparent",
                              }}
                            >
                              <SubFolderChevron
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleSubFolderTree(bundle.id, sf.code);
                                  if (!activeDoc) handleBack();
                                }}
                              >
                                {isSFOpen ? (
                                  <IcoChevronDown size={9} color={G.teal} />
                                ) : (
                                  <IcoChevronRight
                                    size={9}
                                    color={G.slate400}
                                  />
                                )}
                              </SubFolderChevron>

                              {isRenamingThisSf ? (
                                <SidebarRenameInput
                                  ref={sidebarSfRenameRef}
                                  $small
                                  value={sidebarRenameSfValue}
                                  onChange={(e) =>
                                    setSidebarRenameSfValue(e.target.value)
                                  }
                                  onClick={(e) => e.stopPropagation()}
                                  onBlur={() =>
                                    commitSidebarSfRename(bundle.id, sf.code)
                                  }
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter")
                                      commitSidebarSfRename(bundle.id, sf.code);
                                    if (e.key === "Escape")
                                      cancelSidebarSfRename();
                                  }}
                                />
                              ) : (
                                <SubFolderNavContent
                                  onClick={() => {
                                    if (activeDoc) {
                                      toggleSubFolderTree(bundle.id, sf.code);
                                      return;
                                    }
                                    handleNavSelectSubFolder(
                                      bundle.id,
                                      sf.code,
                                    );
                                    handleBack();
                                  }}
                                >
                                  <IcoFolder
                                    size={11}
                                    color={
                                      !activeDoc &&
                                      isSFActive &&
                                      activeTabNum == null
                                        ? G.teal
                                        : G.tealDark
                                    }
                                  />
                                  <SubFolderPrefixChip
                                    $active={
                                      !activeDoc &&
                                      isSFActive &&
                                      activeTabNum == null
                                    }
                                  >
                                    {sf.code}
                                  </SubFolderPrefixChip>
                                  <SubFolderName
                                    $active={
                                      !activeDoc &&
                                      isSFActive &&
                                      activeTabNum == null
                                    }
                                  >
                                    {sf.name}
                                  </SubFolderName>
                                </SubFolderNavContent>
                              )}
                              <NavBadge
                                $active={
                                  !activeDoc &&
                                  isSFActive &&
                                  activeTabNum == null
                                }
                              >
                                {tabGroups.length}
                              </NavBadge>
                            </SubFolderNavRow>

                            {isSFOpen && (
                              <TabNavList>
                                {tabGroups.length === 0 && (
                                  <TabNavEmpty>No tabs</TabNavEmpty>
                                )}
                                {tabGroups.map((tg) => {
                                  const firstRow = tg.rows?.[0] || {};
                                  const docObj = {
                                    id: bundle.id,
                                    name:
                                      tg.docName ||
                                      firstRow.userLabel ||
                                      "Untitled Document",
                                    type: "pdf",
                                    s3url:
                                      firstRow?.bundleDocumentUrl ||
                                      firstRow?.fileUrl,
                                    visibilityType: firstRow?.visibilityType,
                                    bundle: true,
                                    sourceDocId: firstRow.sourceDocId,
                                    bundlecode: sf.code,
                                    tabNum: tg.tabNum,
                                  };
                                  const isTabActive = activeDoc
                                    ? getDocViewerKey(activeDoc) ===
                                      getDocViewerKey(docObj)
                                    : isSFActive &&
                                      String(activeTabNum) ===
                                        String(tg.tabNum);
                                  return (
                                    <TabNavRow
                                      key={tg.tabNum}
                                      $active={isTabActive}
                                      {...prefetchHandlers(docObj.s3url)}
                                      onClick={() => {
                                        if (activeDoc) {
                                          handleOpenDoc(docObj);
                                          return;
                                        }
                                        handleNavSelectTab(
                                          bundle.id,
                                          sf.code,
                                          tg.tabNum,
                                        );
                                        handleBack();
                                      }}
                                      onContextMenu={(e) =>
                                        bundle.ownerRole === "caseManager" &&
                                        bundle.ownerId === userObject?.id
                                          ? startSidebarMoveDoc(
                                              e,
                                              bundle.id,
                                              sf.code,
                                              tg,
                                            )
                                          : {}
                                      }
                                      title="Right-click to move to another folder"
                                      style={{
                                        paddingLeft: 36,
                                        borderLeft: `3px solid ${isTabActive ? G.teal : G.tealMid}`,
                                        marginLeft: 8,
                                        borderRadius: 0,
                                      }}
                                    >
                                      <IcoFile
                                        size={10}
                                        color={
                                          isTabActive ? G.teal : G.slate400
                                        }
                                      />
                                      <TabNavLabel $active={isTabActive}>
                                        {tg.docName || `Tab ${tg.tabNum}`}
                                      </TabNavLabel>
                                      <TabNavCount $active={isTabActive}>
                                        {tg.totalPages}p
                                      </TabNavCount>
                                    </TabNavRow>
                                  );
                                })}
                              </TabNavList>
                            )}
                          </div>
                        );
                      })}

                      {subFolders.filter((sf) => !sf.isMainFolder).length ===
                        0 &&
                        bundle.ownerRole === "caseManager" &&
                        bundle.ownerId === userObject?.id &&
                        subFolders.every((sf) => sf.isMainFolder) && (
                          <SubNavEmpty style={{ paddingLeft: 8 }}>
                            <AddSubFolderInline
                              onClick={() => {
                                handleOpenCreateSubFolder(bundle.id);
                                handleBack();
                              }}
                            >
                              + Add sub-folder
                            </AddSubFolderInline>
                          </SubNavEmpty>
                        )}
                    </SubFolderNavList>
                  )}
                </div>
              );
            })}
          </SubNav>
        )}
      </NavSection>
      <NavSection>
        <NavRow
          $active={!activeDoc && activeSection === "private" && !activeBundleId}
          onClick={() => {
            setPrivateExpanded((v) => !v);
            handleSectionSwitch("private");
            handleBack();
          }}
        >
          <ChevronWrap>
            {privateExpanded ? <IcoChevronDown /> : <IcoChevronRight />}
          </ChevronWrap>
          <NavIconWrap>
            <IcoLock
              size={14}
              color={
                !activeDoc && activeSection === "private" && !activeBundleId
                  ? G.teal
                  : G.slate500
              }
            />
          </NavIconWrap>
          <NavLabel
            $active={
              !activeDoc && activeSection === "private" && !activeBundleId
            }
          >
            My Private Bundles
          </NavLabel>
          <NavBadge
            $active={
              !activeDoc && activeSection === "private" && !activeBundleId
            }
          >
            {privateBundles.length}
          </NavBadge>
        </NavRow>
        {privateExpanded && (
          <SubNav $flat>
            {privateBundles.length === 0 && (
              <SubNavEmpty>No private bundles yet</SubNavEmpty>
            )}
            {privateBundles.map((bundle) => {
              const isBundleActive =
                activeSection === "private" && activeBundleId === bundle.id;
              return (
                <BundleNavRow
                  key={bundle.id}
                  $active={!activeDoc && isBundleActive}
                >
                  <BundleNavContent
                    onClick={() => {
                      if (activeDoc) {
                        toggleBundleTree(bundle.id);
                        return;
                      }
                      handleNavSelectBundle(bundle.id, "private");
                      handleBack();
                    }}
                  >
                    <IcoLock
                      size={12}
                      color={!activeDoc && isBundleActive ? G.teal : G.slate400}
                    />
                    <BundleNavIdChip $active={!activeDoc && isBundleActive}>
                      {bundle.bundleCode || bundle.id}
                    </BundleNavIdChip>
                    <BundleNavName $active={!activeDoc && isBundleActive}>
                      {bundle.name}
                    </BundleNavName>
                  </BundleNavContent>
                  <NavBadge $active={!activeDoc && isBundleActive}>
                    {(bundle.bundles || []).length}
                  </NavBadge>
                </BundleNavRow>
              );
            })}
          </SubNav>
        )}
      </NavSection>
      <NavSection>
        <NavRow
          $active={!activeDoc && activeSection === "recentlyViewed"}
          onClick={() => {
            setRecentlyViewedExpanded((v) => !v);
          }}
        >
          <ChevronWrap>
            {recentlyViewedExpanded ? <IcoChevronDown /> : <IcoChevronRight />}
          </ChevronWrap>
          <NavIconWrap>
            <IcoClock
              size={14}
              color={
                !activeDoc && activeSection === "recentlyViewed"
                  ? G.teal
                  : G.slate500
              }
            />
          </NavIconWrap>
          <NavLabel $active={!activeDoc && activeSection === "recentlyViewed"}>
            Recently Viewed Documents
          </NavLabel>
          <NavBadge $active={!activeDoc && activeSection === "recentlyViewed"}>
            {recentlyViewedDocs.length}
          </NavBadge>
        </NavRow>
        {recentlyViewedExpanded && (
          <SubNav $flat>
            {recentlyViewedDocs.length === 0 ? (
              <SubNavEmpty>No recently viewed documents.</SubNavEmpty>
            ) : (
              recentlyViewedDocs.map((item) => {
                const isDocActive =
                  activeDoc &&
                  getDocViewerKey(activeDoc) === getDocViewerKey(item.doc);
                return (
                  <BundleNavRow key={item.id} $active={isDocActive}>
                    <BundleNavContent
                      {...prefetchHandlers(item.doc?.s3url)}
                      onClick={() => {
                        handleOpenDoc(item.doc);
                      }}
                      title={item.name}
                    >
                      <IcoFile
                        size={12}
                        color={isDocActive ? G.teal : G.slate400}
                      />
                      <BundleNavName $active={isDocActive}>
                        {truncateDocName(item.name, 35)}
                      </BundleNavName>
                    </BundleNavContent>
                  </BundleNavRow>
                );
              })
            )}
          </SubNav>
        )}
      </NavSection>
      <SidebarSummary>
        <SidebarSummaryItem>
          <strong style={{ color: COLORS.COLOR_DARK }}>
            {trialBundles.length}
          </strong>
          <span>Trial bundles</span>
        </SidebarSummaryItem>
        <SidebarSummaryItem>
          <strong style={{ color: COLORS.COLOR_DARK }}>
            {privateBundles.length}
          </strong>
          <span>Private bundles</span>
        </SidebarSummaryItem>
      </SidebarSummary>
    </>
  );

  const renderTrialBundlesTable = () => {
    const emptyTitle =
      activeSection === "private"
        ? "No private bundles yet"
        : "No trial bundles yet";
    const emptyHint =
      activeSection === "private"
        ? "Change any bundle visibility to Private to show it here."
        : "Create your first trial bundle to organise documents for the hearing.";

    if (trialBundlesLoading && activeBundleList.length === 0) {
      return (
        <EmptyState>
          <Spinner $size="28px" />
          <EmptyText style={{ marginTop: 14 }}>Loading bundles…</EmptyText>
        </EmptyState>
      );
    }

    if (trialBundlesError && activeBundleList.length === 0) {
      return (
        <EmptyState>
          <EmptyText style={{ color: G.red }}>{trialBundlesError}</EmptyText>
          <PrimaryBtn style={{ marginTop: 16 }} onClick={fetchAllBundles}>
            Retry
          </PrimaryBtn>
        </EmptyState>
      );
    }

    if (activeBundleList.length === 0) {
      return (
        <EmptyState>
          <EmptyIconBox
            style={{ background: G.tealLight, borderColor: G.tealMid }}
          >
            <IcoLayers size={28} color={G.teal} />
          </EmptyIconBox>
          <EmptyText>{emptyTitle}</EmptyText>
          <EmptyHint>{emptyHint}</EmptyHint>
          {activeSection !== "private" && (
            <PrimaryBtn
              style={{ marginTop: 20 }}
              onClick={() => setShowCreateModal(true)}
            >
              <IcoPlus size={13} /> Create Trial Bundle
            </PrimaryBtn>
          )}
        </EmptyState>
      );
    }

    const bundlesToShow = activeBundleId
      ? filteredTrialBundles.filter((b) => b.id === activeBundleId)
      : filteredTrialBundles;

    return (
      <BundlesWrap>
        <BundleSearchBar>
          <IcoSearch size={14} color={G.slate400} />
          <input
            placeholder="Search bundles, sub-folders, prefixes, documents…"
            value={bundleSearch}
            onChange={(e) => setBundleSearch(e.target.value)}
          />
          {bundleSearch && (
            <ClearSearchBtn onClick={() => setBundleSearch("")}>
              <IcoX size={11} color={G.slate400} />
            </ClearSearchBtn>
          )}
        </BundleSearchBar>

        {bundleSearch && filteredTrialBundles.length === 0 && (
          <NoResultsBanner>
            No bundles match "<strong>{bundleSearch}</strong>"
          </NoResultsBanner>
        )}

        {bundlesToShow.map((bundle) => {
          const realIdx = trialBundles.findIndex((b) => b.id === bundle.id);
          const subFolders = getBundleSubFolders(bundle);
          const sfToShow = activeSubFolder
            ? subFolders.filter((sf) => sf.code === activeSubFolder)
            : subFolders;
          const visibleSubFolderCount = getVisibleSubFolderCount(bundle);

          const totalAssignments = subFolders.reduce(
            (sum, sf) =>
              sum +
              (sf.assignments || []).reduce(
                (pSum, a) => pSum + parsePageCount(a.pages),
                0,
              ),
            0,
          );
          const totalTabs = subFolders.reduce(
            (sum, sf) => sum + getSubFolderTabGroups(sf).length,
            0,
          );

          const selectedKeysForBundle = Object.keys(selectedRows).filter(
            (key) => key.startsWith(`${bundle.id}:`) && selectedRows[key],
          );

          return (
            <BundleBlock key={bundle.id}>
              {/* Bundle header */}
              <BundleHeader
                $isDragOver={
                  dropTarget &&
                  dropTarget.bundleId === bundle.id &&
                  dropTarget.sfCode ===
                    (bundle.hasBundleFolders ? "__flat__" : "__main__")
                }
                onDragOver={(e) =>
                  handleDragOver(
                    e,
                    bundle.id,
                    bundle.hasBundleFolders ? "__flat__" : "__main__",
                  )
                }
                onDragLeave={handleDragLeave}
                onDrop={(e) =>
                  handleDrop(
                    e,
                    bundle.id,
                    bundle.hasBundleFolders ? "__flat__" : "__main__",
                  )
                }
                onClick={() => {
                  if (activeBundleId !== bundle.id)
                    handleOpenBundleInTable(bundle);
                }}
              >
                <BundleHeaderLeft>
                  <BundleHeaderTop>
                    {renamingBundleId === bundle.id ? (
                      <RenameInput
                        autoFocus
                        value={renameValue}
                        onChange={(e) => setRenameValue(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                        onBlur={() => commitRename(bundle.id)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") commitRename(bundle.id);
                          if (e.key === "Escape") {
                            setRenamingBundleId(null);
                            setRenameValue("");
                          }
                        }}
                      />
                    ) : (
                      <BundleTitle>
                        <BundleIdChip>{bundle.name || bundle.id}</BundleIdChip>
                      </BundleTitle>
                    )}
                  </BundleHeaderTop>
                  {bundle.ownerRole === "caseManager" &&
                    bundle.ownerId !== userObject?.id && (
                      <BundleMeta>
                        <VisibilityBadge
                          $visibility={bundle.visibilityType || "me"}
                          style={{
                            background: "rgba(255,255,255,0.12)",
                            border: "1px solid rgba(255,255,255,0.2)",
                            color: "#fff",
                            fontSize: "10px",
                          }}
                        >
                          {getVisibilityLabel(bundle.visibilityType)}
                        </VisibilityBadge>
                      </BundleMeta>
                    )}
                  <BundleStats>
                    <BundleStat>
                      <span>Sub Folders</span>
                      <strong>{visibleSubFolderCount}</strong>
                    </BundleStat>
                    <BundleStat>
                      <span>Tabs</span>
                      <strong>{totalTabs}</strong>
                    </BundleStat>
                    <BundleStat>
                      <span>Pages</span>
                      <strong>{totalAssignments}</strong>
                    </BundleStat>
                  </BundleStats>
                </BundleHeaderLeft>
                <BundleHeaderActions onClick={(e) => e.stopPropagation()}>
                  <AddSubFolderBtn
                    onClick={() => handleDownloadBundle(bundle.id)}
                    title="Download entire bundle"
                  >
                    <IcoDownload size={13} color={G.teal} />
                    <span>Download</span>
                  </AddSubFolderBtn>
                </BundleHeaderActions>
                {bundle.ownerRole === "caseManager" &&
                bundle.ownerId === userObject?.id ? (
                  <BundleHeaderActions onClick={(e) => e.stopPropagation()}>
                    <VisibilitySelect
                      value={bundle.visibilityType}
                      onChange={(value) =>
                        handleBundleVisibilityChange(bundle.id, value)
                      }
                    />
                    <AddSubFolderBtn
                      onClick={() => handleOpenCreateSubFolder(bundle.id)}
                      title="Add Sub-folder"
                    >
                      <IcoFolderPlus size={13} color={G.teal} />
                      <span>Sub-folder</span>
                    </AddSubFolderBtn>
                    <AddSubFolderBtn
                      onClick={() => {
                        const mainSf = (bundle.bundles || []).find(
                          (sf) => sf.isMainFolder,
                        );
                        if (mainSf) {
                          openUploadDocs(bundle, mainSf);
                        } else {
                          openUploadDocs(bundle, {
                            code: "__main__",
                            name: bundle.name,
                            isMainFolder: true,
                            assignments: [],
                          });
                        }
                      }}
                      title="Upload to Bundle"
                    >
                      <IcoUpload size={13} color={G.teal} />
                      <span>Upload</span>
                    </AddSubFolderBtn>
                    {selectedKeysForBundle.length > 0 && (
                      <DeleteSelectedBtn
                        onClick={() =>
                          deleteMultipleBundleDocuments(
                            selectedKeysForBundle,
                            bundle.bundleCode,
                          )
                        }
                        title="Delete Selected Documents"
                      >
                        <IcoTrash size={12} />
                        <span>
                          Delete Selected ({selectedKeysForBundle.length})
                        </span>
                      </DeleteSelectedBtn>
                    )}
                    <BundleContextMenu
                      bundle={bundle}
                      bundleIdx={realIdx}
                      totalBundles={trialBundles.length}
                      onRename={handleRenameBundle}
                      onMoveUp={handleMoveBundleUp}
                      onMoveDown={handleMoveBundleDown}
                      onDelete={handleDeleteBundle}
                      onCreateSubFolder={handleOpenCreateSubFolder}
                    />
                  </BundleHeaderActions>
                ) : null}
              </BundleHeader>

              {sfToShow.length === 0 ? (
                <EmptyRowBlock>
                  <IcoFolder size={16} color={G.slate300} />
                  <span>No sub-folders in this bundle.</span>
                  <AddSubFolderBtn
                    onClick={() => handleOpenCreateSubFolder(bundle.id)}
                    style={{ marginLeft: 8 }}
                  >
                    <IcoFolderPlus size={12} color={G.teal} />
                    <span>Create sub-folder</span>
                  </AddSubFolderBtn>

                  {bundle.ownerRole === "caseManager" &&
                    bundle.ownerId === userObject?.id && (
                      <AddSubFolderBtn
                        onClick={() =>
                          openUploadDocs(bundle, {
                            code: "__main__",
                            name: bundle.name,
                            isMainFolder: true,
                            assignments: [],
                          })
                        }
                        style={{ marginLeft: 8 }}
                      >
                        <IcoUpload size={12} color={G.teal} />
                        <span>Upload Files</span>
                      </AddSubFolderBtn>
                    )}
                </EmptyRowBlock>
              ) : (
                sfToShow.map((sf) => {
                  const tabGroups = getSubFolderTabGroups(sf);
                  const tabsToShow =
                    activeSubFolder && activeTabNum != null
                      ? tabGroups.filter((tg) => tg.tabNum === activeTabNum)
                      : tabGroups;
                  const realSfIdx = subFolders.findIndex(
                    (s) => s.code === sf.code,
                  );

                  return (
                    <SubFolderBlock key={sf.code}>
                      {!sf.isMainFolder && (
                        <SubFolderHeader
                          $isDragOver={
                            dropTarget &&
                            dropTarget.bundleId === bundle.id &&
                            dropTarget.sfCode === sf.code
                          }
                          onDragOver={(e) =>
                            handleDragOver(e, bundle.id, sf.code)
                          }
                          onDragLeave={handleDragLeave}
                          onDrop={(e) => handleDrop(e, bundle.id, sf.code)}
                        >
                          <SfHeaderLeft>
                            {renamingSfBundleId === bundle.id &&
                            renamingSfCode === sf.code ? (
                              <RenameInput
                                autoFocus
                                value={renameSfValue}
                                onChange={(e) =>
                                  setRenameSfValue(e.target.value)
                                }
                                onBlur={() =>
                                  commitRenameSf(bundle.id, sf.code)
                                }
                                onKeyDown={(e) => {
                                  if (e.key === "Enter")
                                    commitRenameSf(bundle.id, sf.code);
                                  if (e.key === "Escape") {
                                    setRenamingSfBundleId(null);
                                    setRenamingSfCode(null);
                                  }
                                }}
                                style={{ maxWidth: 180 }}
                              />
                            ) : (
                              <>
                                <SfName
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <SfLabel>Sub-folder:</SfLabel>
                                  <Highlight
                                    text={sf.name}
                                    query={bundleSearch}
                                  />
                                  {getExhibitId(sf) && (
                                    <span
                                      style={{
                                        marginLeft: 8,
                                        fontSize: 11,
                                        color: "#64748b",
                                        background: "#e2e8f0",
                                        padding: "2px 6px",
                                        borderRadius: "4px",
                                        fontWeight: "normal",
                                      }}
                                    >
                                      Exhibit ID: {getExhibitId(sf)}
                                    </span>
                                  )}
                                </SfName>
                              </>
                            )}
                          </SfHeaderLeft>
                          <SfHeaderRight>
                            <QuickUploadBtn
                              onClick={() =>
                                handleDownloadBundle(
                                  bundle.id,
                                  sf.code,
                                  sf.name,
                                )
                              }
                              title="Download Folder"
                              style={{ marginRight: 8 }}
                            >
                              <IcoDownload size={12} color={G.teal} />
                            </QuickUploadBtn>
                            {bundle.ownerRole === "caseManager" &&
                              bundle.ownerId === userObject?.id && (
                                <QuickUploadBtn
                                  onClick={() => openUploadDocs(bundle, sf)}
                                  title="Upload Files to Folder"
                                >
                                  <IcoUpload size={12} color={G.teal} />
                                </QuickUploadBtn>
                              )}
                            {bundle.ownerRole === "caseManager" &&
                              bundle.ownerId === userObject?.id && (
                                <SubFolderContextMenu
                                  sf={sf}
                                  sfIdx={realSfIdx}
                                  totalSf={visibleSubFolderCount}
                                  onRename={(code) =>
                                    handleRenameSubFolder(bundle.id, code)
                                  }
                                  onMoveUp={(i) =>
                                    handleMoveSubFolderUp(bundle.id, i)
                                  }
                                  onMoveDown={(i) =>
                                    handleMoveSubFolderDown(bundle.id, i)
                                  }
                                  onDelete={(code) =>
                                    handleDeleteSubFolder(bundle.id, code)
                                  }
                                  onUpload={() => openUploadDocs(bundle, sf)}
                                  onCombine={() => {}}
                                  onCopyTo={() => {}}
                                  onDownload={() =>
                                    handleDownloadBundle(
                                      bundle.id,
                                      sf.code,
                                      sf.name,
                                    )
                                  }
                                />
                              )}
                          </SfHeaderRight>
                        </SubFolderHeader>
                      )}
                      <TableWrap>
                        <InnerTable>
                          <thead>
                            <InnerTr $head>
                              {bundle.ownerRole === "caseManager" &&
                                bundle.ownerId === userObject?.id && (
                                  <ColTh
                                    style={{ width: 44, paddingLeft: 16 }}
                                  />
                                )}
                              <ColTh style={{ width: 130, paddingLeft: 16 }}>
                                TAB / REF
                              </ColTh>
                              <ColTh>DESCRIPTION OF DOCUMENT</ColTh>
                              <ColTh style={{ width: 110 }}>EXHIBIT ID</ColTh>
                              {bundle.ownerRole === "caseManager" &&
                                bundle.ownerId === userObject?.id && (
                                  <ColTh style={{ width: 100 }}>ACTIONS</ColTh>
                                )}
                            </InnerTr>
                          </thead>
                          <tbody>
                            {tabsToShow.length === 0 ? (
                              <tr>
                                <EmptyRowTd colSpan={8}>
                                  {activeTabNum != null
                                    ? `No pages assigned to Tab ${activeTabNum}.`
                                    : "No pages assigned to this sub-folder yet."}
                                  {bundle.ownerRole === "caseManager" &&
                                    bundle.ownerId === userObject?.id &&
                                    activeTabNum == null && (
                                      <>
                                        {" "}
                                        <EmptyRowUploadLink
                                          onClick={() =>
                                            openUploadDocs(bundle, sf)
                                          }
                                        >
                                          Upload files
                                        </EmptyRowUploadLink>
                                      </>
                                    )}
                                </EmptyRowTd>
                              </tr>
                            ) : (
                              tabsToShow.map((tg) => {
                                const rowKey = `${bundle.id}:${sf.code}:${tg.tabNum}`;
                                const firstRow = tg.rows[0] || {};
                                const totalPagesInTab = tg.totalPages || 0;
                                const canMoveRow = canMoveAssignment(
                                  firstRow,
                                  bundle,
                                  sf,
                                );
                                const subFoldersList = [
                                  ...(bundle.bundles || []),
                                ];
                                const hasMain = subFoldersList.some(
                                  (s) => s.isMainFolder,
                                );
                                if (!hasMain && bundle.hasBundleFolders) {
                                  subFoldersList.push({
                                    code: "__flat__",
                                    isMainFolder: true,
                                    visibilityType:
                                      bundle.visibilityType || "me",
                                  });
                                }
                                const targetSubFoldersCount =
                                  subFoldersList.filter((s) => {
                                    if (s.code === sf.code) return false;
                                    if (activeSection === "private") {
                                      return (
                                        s.visibilityType === "strictMode" ||
                                        s.visibilityType === "me"
                                      );
                                    }
                                    return true;
                                  }).length;

                                return (
                                  <React.Fragment key={tg.tabNum}>
                                    <tr>
                                      <TabSeparatorTd colSpan={8}>
                                        <TabSepInner>
                                          <TabLabelGroup>
                                            <TabLabel></TabLabel>
                                          </TabLabelGroup>
                                          <TabSepMeta></TabSepMeta>
                                        </TabSepInner>
                                      </TabSeparatorTd>
                                    </tr>
                                    <DataRow
                                      $selected={!!selectedRows[rowKey]}
                                      $isDragging={
                                        dragState &&
                                        dragState.bundleId === bundle.id &&
                                        dragState.sfCode === sf.code &&
                                        dragState.tabNum === tg.tabNum
                                      }
                                      $isReorderOver={
                                        dropTarget &&
                                        dropTarget.bundleId === bundle.id &&
                                        dropTarget.sfCode === sf.code &&
                                        dropTarget.isReorder &&
                                        dropTarget.targetTabNum === tg.tabNum
                                      }
                                      draggable={
                                        bundle.ownerRole === "caseManager" &&
                                        bundle.ownerId === userObject?.id
                                      }
                                      onDragStart={(e) =>
                                        handleDragStart(e, bundle, sf, tg)
                                      }
                                      onDragOver={(e) =>
                                        handleDragOverRow(
                                          e,
                                          bundle.id,
                                          sf.code,
                                          tg.tabNum,
                                        )
                                      }
                                      onDragLeave={handleDragLeave}
                                      onDrop={(e) =>
                                        handleDrop(
                                          e,
                                          bundle.id,
                                          sf.code,
                                          tg.tabNum,
                                        )
                                      }
                                      onDragEnd={handleDragEnd}
                                    >
                                      {bundle.ownerRole === "caseManager" &&
                                        bundle.ownerId === userObject?.id && (
                                          <td
                                            style={{
                                              width: 60,
                                              paddingLeft: 16,
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "6px",
                                              }}
                                            >
                                              <DragHandle title="Drag to move document">
                                                ⠿
                                              </DragHandle>
                                              <Checkbox
                                                type="checkbox"
                                                checked={!!selectedRows[rowKey]}
                                                onChange={() =>
                                                  toggleRow(rowKey)
                                                }
                                              />
                                            </div>
                                          </td>
                                        )}
                                      <td
                                        style={{ width: 130, paddingLeft: 16 }}
                                      >
                                        <RefChip>
                                          {bundle.bundleCode}/{tg.tabNum}
                                        </RefChip>
                                      </td>
                                      <td>
                                        <DocDescRow>
                                          <DocIconFrame>
                                            <IcoFile size={13} color={G.teal} />
                                          </DocIconFrame>
                                          <div>
                                            <DocDescText
                                              title={
                                                tg.docName ||
                                                firstRow.userLabel ||
                                                "Untitled Document"
                                              }
                                              {...prefetchHandlers(
                                                firstRow?.bundleDocumentUrl ||
                                                  firstRow?.fileUrl,
                                              )}
                                              onClick={() =>
                                                handleOpenDoc({
                                                  id: bundle.id,
                                                  name:
                                                    tg.docName ||
                                                    firstRow.userLabel ||
                                                    "Untitled Document",
                                                  type: "pdf",
                                                  s3url:
                                                    firstRow?.bundleDocumentUrl ||
                                                    firstRow?.fileUrl,
                                                  visibilityType:
                                                    firstRow?.visibilityType,
                                                  hideVisibility:
                                                    bundle.ownerRole ===
                                                      "caseManager" &&
                                                    bundle.ownerId ===
                                                      userObject?.id,
                                                  bundle: true,
                                                  sourceDocId:
                                                    firstRow.sourceDocId,
                                                  bundlecode: sf.code,
                                                  tabNum: tg.tabNum,
                                                })
                                              }
                                            >
                                              <Highlight
                                                text={truncateDocName(
                                                  tg.docName ||
                                                    firstRow.userLabel ||
                                                    "Untitled Document",
                                                )}
                                                query={bundleSearch}
                                              />
                                            </DocDescText>
                                            <DocDescMeta>
                                              Bundle document
                                              {getExhibitId(firstRow) && (
                                                <>
                                                  <MetaDivider />
                                                  Exhibit ID:{" "}
                                                  {getExhibitId(firstRow)}
                                                </>
                                              )}
                                              <MetaDivider />
                                              {totalPagesInTab} page
                                              {totalPagesInTab > 1 ? "s" : ""}
                                            </DocDescMeta>
                                          </div>
                                        </DocDescRow>
                                      </td>
                                      <td style={{ width: 110 }}>
                                        <div
                                          style={{
                                            fontSize: 13,
                                            color: G.slate700,
                                            fontWeight: 500,
                                          }}
                                        >
                                          {getExhibitId(firstRow) || "—"}
                                        </div>
                                      </td>
                                      {bundle.ownerRole === "caseManager" &&
                                        bundle.ownerId === userObject?.id && (
                                          <td style={{ width: 100 }}>
                                            <RowActions>
                                              {targetSubFoldersCount > 0 && (
                                                <Tooltip
                                                  title={
                                                    canMoveRow
                                                      ? "Move to another sub-folder"
                                                      : "Only private documents can be moved here"
                                                  }
                                                  placement="top"
                                                >
                                                  <MoveBtn
                                                    disabled={!canMoveRow}
                                                    onClick={() =>
                                                      openMoveDoc(
                                                        firstRow,
                                                        bundle.id,
                                                        sf.code,
                                                        bundle,
                                                        sf,
                                                      )
                                                    }
                                                  >
                                                    <IcoMove
                                                      size={12}
                                                      color={G.slate400}
                                                    />
                                                  </MoveBtn>
                                                </Tooltip>
                                              )}
                                              <DeleteIconBtn
                                                disabled={
                                                  selectedKeysForBundle.length >
                                                  0
                                                }
                                                onClick={(e) => {
                                                  if (
                                                    selectedKeysForBundle.length >
                                                    0
                                                  )
                                                    return;
                                                  e.stopPropagation();
                                                  deleteBunleDocument(
                                                    bundle.id,
                                                    sf.code,
                                                    firstRow.sourceDocId,
                                                    bundle.bundleCode,
                                                    tg.tabNum,
                                                    sf.isMainFolder,
                                                  );
                                                }}
                                              >
                                                <IcoTrash
                                                  size={13}
                                                  color={G.red}
                                                />
                                              </DeleteIconBtn>
                                            </RowActions>
                                          </td>
                                        )}
                                    </DataRow>
                                  </React.Fragment>
                                );
                              })
                            )}
                          </tbody>
                        </InnerTable>
                      </TableWrap>
                      <MobileSfCards>
                        {tabsToShow.length === 0 && (
                          <MobileEmpty>
                            No tabs assigned.
                            {bundle.ownerRole === "caseManager" &&
                              bundle.ownerId === userObject?.id && (
                                <>
                                  {" "}
                                  <EmptyRowUploadLink
                                    onClick={() => openUploadDocs(bundle, sf)}
                                  >
                                    Upload files
                                  </EmptyRowUploadLink>
                                </>
                              )}
                          </MobileEmpty>
                        )}
                        {tabsToShow.map((tg) => {
                          const rowKey = `${bundle.id}:${sf.code}:${tg.tabNum}`;
                          const firstRow = tg.rows[0] || {};
                          const canMoveRow = canMoveAssignment(
                            firstRow,
                            bundle,
                            sf,
                          );
                          const subFoldersList = [...(bundle.bundles || [])];
                          const hasMain = subFoldersList.some(
                            (s) => s.isMainFolder,
                          );
                          if (!hasMain && bundle.hasBundleFolders) {
                            subFoldersList.push({
                              code: "__flat__",
                              isMainFolder: true,
                              visibilityType: bundle.visibilityType || "me",
                            });
                          }
                          const targetSubFoldersCount = subFoldersList.filter(
                            (s) => {
                              if (s.code === sf.code) return false;
                              if (activeSection === "private") {
                                return (
                                  s.visibilityType === "strictMode" ||
                                  s.visibilityType === "me"
                                );
                              }
                              return true;
                            },
                          ).length;
                          return (
                            <MobileSfCard
                              key={tg.tabNum}
                              $selected={!!selectedRows[rowKey]}
                            >
                              <MobileSfCardTop>
                                <RefChip>
                                  {sf.code}/{tg.tabNum}
                                </RefChip>
                                <TabLabel>TAB {tg.tabNum}</TabLabel>
                                {bundle.ownerRole === "caseManager" &&
                                  bundle.ownerId === userObject?.id && (
                                    <Checkbox
                                      type="checkbox"
                                      checked={!!selectedRows[rowKey]}
                                      onChange={() => toggleRow(rowKey)}
                                    />
                                  )}
                              </MobileSfCardTop>
                              <MobileSfCardName
                                {...prefetchHandlers(
                                  firstRow?.bundleDocumentUrl ||
                                    firstRow?.fileUrl,
                                )}
                                onClick={() =>
                                  handleOpenDoc({
                                    id: bundle.id,
                                    name:
                                      tg.docName ||
                                      firstRow.userLabel ||
                                      "Untitled Document",
                                    type: "pdf",
                                    s3url:
                                      firstRow?.bundleDocumentUrl ||
                                      firstRow?.fileUrl,
                                    visibilityType: firstRow?.visibilityType,
                                    hideVisibility:
                                      bundle.ownerRole === "caseManager" &&
                                      bundle.ownerId === userObject?.id,
                                    bundle: true,
                                    sourceDocId: firstRow.sourceDocId,
                                    bundlecode: sf.code,
                                    tabNum: tg.tabNum,
                                  })
                                }
                              >
                                <IcoFile size={12} color={G.slate400} />
                                <span>
                                  <Highlight
                                    text={
                                      tg.docName ||
                                      firstRow.userLabel ||
                                      "Untitled Document"
                                    }
                                    query={bundleSearch}
                                  />
                                </span>
                              </MobileSfCardName>
                              <MobileSfCardMeta>
                                {firstRow.source && (
                                  <SourceBadge source={firstRow.source} />
                                )}
                                <DateText>
                                  {firstRow.date
                                    ? moment(firstRow.date).format(
                                        "DD MMM YYYY",
                                      )
                                    : "—"}
                                </DateText>
                                {targetSubFoldersCount > 0 ? (
                                  <MoveBtn
                                    disabled={!canMoveRow}
                                    onClick={() =>
                                      openMoveDoc(
                                        firstRow,
                                        bundle.id,
                                        sf.code,
                                        bundle,
                                        sf,
                                      )
                                    }
                                    style={{ marginLeft: "auto" }}
                                  >
                                    <IcoMove size={12} color={G.slate400} />
                                  </MoveBtn>
                                ) : (
                                  <div style={{ marginLeft: "auto" }} />
                                )}

                                <DeleteIconBtn
                                  disabled={selectedKeysForBundle.length > 0}
                                  onClick={(e) => {
                                    if (selectedKeysForBundle.length > 0)
                                      return;
                                    e.stopPropagation();
                                    deleteBunleDocument(
                                      bundle.id,
                                      sf.code,
                                      firstRow.sourceDocId,
                                      bundle.bundleCode,
                                      tg.tabNum,
                                      sf.isMainFolder,
                                    );
                                  }}
                                >
                                  <IcoTrash size={13} color={G.red} />
                                </DeleteIconBtn>
                              </MobileSfCardMeta>
                            </MobileSfCard>
                          );
                        })}
                      </MobileSfCards>
                    </SubFolderBlock>
                  );
                })
              )}
            </BundleBlock>
          );
        })}
      </BundlesWrap>
    );
  };
  return (
    <Shell>
      {!compareViewActive && sidebarOpen && (
        <Overlay onClick={() => setSidebarOpen(false)} />
      )}
      {!compareViewActive && (
        <Sidebar $open={sidebarOpen} $collapsed={sidebarCollapsed}>
          {sidebarCollapsed ? (
            <CollapsedSidebarBar>
              <SidebarToggleBtn
                onClick={() => setSidebarCollapsed(false)}
                title="Expand sidebar"
              >
                <SidebarExpandIcon size={16} color={G.teal} />
              </SidebarToggleBtn>
            </CollapsedSidebarBar>
          ) : (
            <>
              <SidebarHeader>
                <SidebarTitle>Documents & Bundles</SidebarTitle>
                <SidebarToggleBtn
                  onClick={() => setSidebarCollapsed(true)}
                  title="Collapse sidebar"
                >
                  <SidebarCollapseIcon size={15} color={G.slate600} />
                </SidebarToggleBtn>
              </SidebarHeader>
              {renderSidebar()}
            </>
          )}
        </Sidebar>
      )}

      <Main>
        {activeDoc ? null : (
          <TopBar>
            <TopLeft>
              <HamburgerBtn onClick={() => setSidebarOpen((v) => !v)}>
                <IcoMenu size={18} color={G.slate700} />
              </HamburgerBtn>
              <BackBtn
                onClick={() => {
                  updateUrlSilently(
                    getCaseBasePath(id, caseDetails?.resolutionKind),
                  );
                  if (onBack) onBack();
                }}
                title="Back"
              >
                <IcoChevronLeft size={13} color={G.teal} />
              </BackBtn>
              <PageIconBox>{meta.icon}</PageIconBox>
              <PageTitleGroup>
                <PageTitle>
                  {activeSection === "trial" ? getTrialViewTitle() : meta.title}
                </PageTitle>
                <PageSub>
                  {activeSection === "core" ? `${totalDocs} documents` : null}
                </PageSub>
              </PageTitleGroup>
            </TopLeft>

            {activeSection === "core" && (
              <AddDocument
                {...{
                  id,
                  caseDetails,
                  isActionsDisabled,
                  enableWhatsAppAttachmentNotification: true,
                  enableRedaction: true,
                }}
                setTrigger={() =>
                  fetchDocuments(currentPage, itemsPerPage, activeSource)
                }
                renderAs={({ onClick }) => (
                  <PrimaryBtn onClick={onClick}>
                    <IcoUpload size={13} /> <span>Upload Core Bundles</span>
                  </PrimaryBtn>
                )}
              />
            )}
            {activeSection === "trial" && (
              <>
                {trialBundles.length >= 2 ? (
                  <SecondaryBtn
                    onClick={() => setShowCombineModal(true)}
                    title="Combine bundles"
                  >
                    <span>Combine</span>
                  </SecondaryBtn>
                ) : null}
                <PrimaryBtn onClick={() => setShowCreateModal(true)}>
                  <IcoPlus size={13} /> <span>New Bundle</span>
                </PrimaryBtn>
              </>
            )}
          </TopBar>
        )}

        <ViewportWrap>
          {activeSection === "core" && (
            <FilterStrip>
              <FilterLabel>Filter by source</FilterLabel>
              <FilterPills>
                {["All", "Claimant", "Respondent", "Neutral"].map((src) => (
                  <Pill
                    key={src}
                    $active={activeSource === src}
                    onClick={() => handleSourceChange(src)}
                  >
                    {src !== "All" && (
                      <SourceDot $source={src} style={{ marginRight: 5 }} />
                    )}
                    {src}
                  </Pill>
                ))}
              </FilterPills>
            </FilterStrip>
          )}

          <SectionBar></SectionBar>

          {activeSection === "core" && (
            <Content>
              {loading && (
                <EmptyState>
                  <Spinner $size="28px" />
                  <EmptyText style={{ marginTop: 14 }}>
                    Loading documents…
                  </EmptyText>
                </EmptyState>
              )}
              {error && (
                <EmptyState>
                  <EmptyText style={{ color: G.red }}>{error}</EmptyText>
                </EmptyState>
              )}
              {!loading && !error && documents.length === 0 && (
                <EmptyState>
                  <EmptyIconBox>
                    <IcoFile size={26} color={G.slate400} />
                  </EmptyIconBox>
                  <EmptyText>No documents found</EmptyText>
                  <EmptyHint>Upload a document to get started</EmptyHint>
                </EmptyState>
              )}

              {documents.length > 0 && (
                <BundlesWrap>
                  <BundleSearchBar>
                    <IcoSearch size={14} color={G.slate400} />
                    <input
                      placeholder="Search documents by name, reference…"
                      value={bundleSearch}
                      onChange={(e) => setBundleSearch(e.target.value)}
                    />
                    {bundleSearch && (
                      <ClearSearchBtn onClick={() => setBundleSearch("")}>
                        <IcoX size={11} color={G.slate400} />
                      </ClearSearchBtn>
                    )}
                  </BundleSearchBar>

                  <BundleBlock>
                    <BundleHeader>
                      <BundleHeaderLeft>
                        <BundleHeaderTop>
                          <BundleTitle>
                            <BundleIdChip>
                              {activeSource === "All"
                                ? "All Documents"
                                : `${activeSource} Documents`}
                            </BundleIdChip>
                          </BundleTitle>
                        </BundleHeaderTop>
                        <BundleStats>
                          <BundleStat>
                            <span>Total</span>
                            <strong>{totalDocs}</strong>
                          </BundleStat>
                          <BundleStat>
                            <span>Showing</span>
                            <strong>{documents.length}</strong>
                          </BundleStat>
                        </BundleStats>
                      </BundleHeaderLeft>
                      <BundleHeaderActions onClick={(e) => e.stopPropagation()}>
                        {selectedCoreCount > 0 && (
                          <AddSubFolderBtn
                            onClick={handleDownloadCoreZip}
                            title={`Download ${selectedCoreCount} Selected Document(s)`}
                            style={{ marginRight: 8 }}
                          >
                            <IcoDownload size={13} color={G.teal} />
                            <span>Download ({selectedCoreCount})</span>
                          </AddSubFolderBtn>
                        )}
                      </BundleHeaderActions>
                    </BundleHeader>

                    <SubFolderBlock>
                      <TableWrap>
                        <InnerTable>
                          <thead>
                            <InnerTr $head>
                              <ColTh style={{ width: 44, paddingLeft: 16 }}>
                                <Checkbox
                                  type="checkbox"
                                  checked={isAllCoreSelected}
                                  ref={(el) => {
                                    if (el)
                                      el.indeterminate = isSomeCoreSelected;
                                  }}
                                  onChange={toggleAllCoreRows}
                                />
                              </ColTh>
                              <ColTh style={{ width: 110, paddingLeft: 16 }}>
                                REF
                              </ColTh>
                              <ColTh>DOCUMENT NAME</ColTh>
                              <ColTh style={{ width: 110 }}>EXHIBIT ID</ColTh>
                              <ColTh style={{ width: 120 }}>DATE</ColTh>
                              <ColTh style={{ width: 70, textAlign: "center" }}>
                                PAGES
                              </ColTh>
                              <ColTh style={{ width: 140 }}>SUBMITTED BY</ColTh>
                              {!viewOnly && (
                                <ColTh style={{ width: 120 }}>TYPE</ColTh>
                              )}
                              <ColTh style={{ width: 90, textAlign: "center" }}>
                                VISIBILITY
                              </ColTh>
                              {!viewOnly && (
                                <ColTh
                                  style={{ width: 84, textAlign: "center" }}
                                >
                                  ACTIONS
                                </ColTh>
                              )}
                            </InnerTr>
                          </thead>
                          <tbody>
                            {filteredDocuments.map((doc) => {
                              const isCMEditable =
                                doc?.ownerType === "caseManager" &&
                                doc?.ownerId === userObject?.id;
                              const isStrictPrivate =
                                doc?.visibilityType === "strictMode";
                              const isTeamPrivate =
                                doc?.visibilityType === "me";
                              const isShared = doc?.visibilityType === "others";
                              const { Icon, title } = isStrictPrivate
                                ? {
                                    Icon: LockIcon,
                                    title: "Private",
                                    clickable: isCMEditable,
                                  }
                                : isTeamPrivate
                                  ? {
                                      Icon: GroupIcon,
                                      title: "Shared with My Team",
                                      clickable: isCMEditable,
                                    }
                                  : isShared
                                    ? {
                                        Icon: HttpsLockOpen,
                                        title: isCMEditable
                                          ? "Shared with Neutral"
                                          : "Shared with CM and Neutral",
                                        clickable: isCMEditable,
                                      }
                                    : {
                                        Icon: PublicIcon,
                                        title: "Public",
                                        clickable: isCMEditable,
                                      };

                              return (
                                <React.Fragment key={doc.id}>
                                  <tr>
                                    <TabSeparatorTd colSpan={viewOnly ? 8 : 10}>
                                      <TabSepInner>
                                        <TabLabelGroup>
                                          <TabLabel />
                                        </TabLabelGroup>
                                        <TabSepMeta />
                                      </TabSepInner>
                                    </TabSeparatorTd>
                                  </tr>
                                  <DataRow
                                    $selected={
                                      !!selectedCoreRows[doc.id] ||
                                      (activeDoc &&
                                        (String(activeDoc.id) ===
                                          String(doc.id) ||
                                          (activeDoc.documentNo &&
                                            String(activeDoc.documentNo) ===
                                              String(doc.documentNo))))
                                    }
                                  >
                                    <td style={{ width: 44, paddingLeft: 16 }}>
                                      <Checkbox
                                        type="checkbox"
                                        checked={!!selectedCoreRows[doc.id]}
                                        onChange={() => toggleCoreRow(doc)}
                                      />
                                    </td>
                                    <td
                                      style={{
                                        width: 110,
                                        paddingLeft: 16,
                                      }}
                                    >
                                      <RefChip
                                        onClick={() =>
                                          window.open(doc.url?.url, "_blank")
                                        }
                                        style={{ cursor: "pointer" }}
                                      >
                                        {doc.documentNo || "—"}
                                      </RefChip>
                                    </td>
                                    <td>
                                      <DocDescRow>
                                        <DocIconFrame>
                                          <IcoFile size={13} color={G.teal} />
                                        </DocIconFrame>
                                        <div>
                                          <DocDescText
                                            title={doc.name}
                                            {...prefetchHandlers(doc?.url?.url)}
                                            onClick={() =>
                                              handleOpenDoc({
                                                id: doc.id,
                                                name: doc.name,
                                                type: doc?.url?.uploadType,
                                                s3url: doc?.url?.url,
                                                visibilityType:
                                                  doc?.visibilityType,
                                                hideVisibility:
                                                  doc?.ownerType ===
                                                    "caseManager" &&
                                                  doc?.ownerId ===
                                                    userObject?.id,
                                                keywords: doc.keywords,
                                                documentSummary:
                                                  doc.documentSummary,
                                                documentNo:
                                                  doc.documentNo ||
                                                  doc.document_no,
                                              })
                                            }
                                          >
                                            <Highlight
                                              text={truncateDocName(doc.name)}
                                              query={bundleSearch}
                                            />
                                          </DocDescText>
                                          <DocDescMeta>
                                            {"Document"}
                                            {getExhibitId(doc) && (
                                              <>
                                                <MetaDivider />
                                                Exhibit ID: {getExhibitId(doc)}
                                              </>
                                            )}
                                            {doc.pageCount != null && (
                                              <>
                                                <MetaDivider />
                                                {doc.pageCount} page
                                                {doc.pageCount !== 1 ? "s" : ""}
                                              </>
                                            )}
                                          </DocDescMeta>
                                        </div>
                                      </DocDescRow>
                                    </td>
                                    <td style={{ width: 110 }}>
                                      <div
                                        style={{
                                          fontSize: 13,
                                          color: G.slate700,
                                          fontWeight: 500,
                                        }}
                                      >
                                        {getExhibitId(doc) || "—"}
                                      </div>
                                    </td>
                                    <td>
                                      <DateLine>{doc.formattedDate}</DateLine>
                                      <TimeLine>{doc.time}</TimeLine>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {doc.pageCount != null ? (
                                        <PageChip>{doc.pageCount}</PageChip>
                                      ) : (
                                        <DimText>…</DimText>
                                      )}
                                    </td>
                                    <td>
                                      <OwnerBadge>
                                        {doc.owner?.name || "—"}
                                      </OwnerBadge>
                                    </td>
                                    {!viewOnly && (
                                      <td>
                                        {doc.entity?.resolutionKind ===
                                        "arbitration" ? (
                                          <DocTypeChange
                                            rowData={doc}
                                            documentTypes={
                                              caseDetails?.documentCategoryandTypes
                                            }
                                          />
                                        ) : (
                                          <DocNameRow>
                                            <DocName>
                                              {doc?.url?.uploadType || "other"}
                                            </DocName>
                                          </DocNameRow>
                                        )}
                                      </td>
                                    )}
                                    <td style={{ textAlign: "center" }}>
                                      <Tooltip title={title} placement="top">
                                        <Icon
                                          style={{
                                            fontSize: 14,
                                            fill: COLORS.COLOR_DARK,
                                            cursor:
                                              doc?.ownerType ===
                                                "caseManager" &&
                                              doc?.ownerId === userObject?.id
                                                ? "pointer"
                                                : "default",
                                          }}
                                          onClick={
                                            doc?.ownerType === "caseManager" &&
                                            doc?.ownerId === userObject?.id
                                              ? () =>
                                                  setModalVisibility({
                                                    state: true,
                                                    metaData: doc,
                                                  })
                                              : undefined
                                          }
                                        />
                                      </Tooltip>
                                    </td>
                                    {!viewOnly && (
                                      <td
                                        style={{
                                          textAlign: "center",
                                          width: 84,
                                        }}
                                      >
                                        <RowActions
                                          style={{ justifyContent: "center" }}
                                        >
                                          {!isStrictPrivate && (
                                            <Tooltip
                                              title="Send WhatsApp Notification"
                                              placement="top"
                                            >
                                              <WhatsAppIconBtn
                                                onClick={() =>
                                                  handleOpenWhatsAppModal(doc)
                                                }
                                              >
                                                <WhatsAppIcon
                                                  style={{
                                                    fontSize: 16,
                                                    color: "#25D366",
                                                  }}
                                                />
                                              </WhatsAppIconBtn>
                                            </Tooltip>
                                          )}
                                          <Tooltip
                                            title="Delete Document"
                                            placement="top"
                                          >
                                            <DeleteIconBtn
                                              onClick={() =>
                                                openDeleteConfirm(doc)
                                              }
                                            >
                                              <IcoTrash
                                                size={13}
                                                color={G.red}
                                              />
                                            </DeleteIconBtn>
                                          </Tooltip>
                                        </RowActions>
                                      </td>
                                    )}
                                  </DataRow>
                                </React.Fragment>
                              );
                            })}
                          </tbody>
                        </InnerTable>
                      </TableWrap>
                      <MobileCardList>
                        {filteredDocuments.map((doc) => (
                          <MobileDocCard
                            key={doc.id}
                            $selected={!!selectedCoreRows[doc.id]}
                            {...prefetchHandlers(doc?.url?.url)}
                            onClick={() =>
                              handleOpenDoc({
                                id: doc.id,
                                name: doc.name,
                                type: doc?.url?.uploadType,
                                s3url: doc?.url?.url,
                                visibilityType: doc?.visibilityType,
                                hideVisibility:
                                  doc.ownerType === "caseManager" &&
                                  doc.ownerId === userObject?.id,
                                documentNo: doc.documentNo || doc.document_no,
                              })
                            }
                          >
                            <Checkbox
                              type="checkbox"
                              checked={!!selectedCoreRows[doc.id]}
                              onChange={(e) => {
                                e.stopPropagation();
                                toggleCoreRow(doc);
                              }}
                              onClick={(e) => e.stopPropagation()}
                              style={{ alignSelf: "center", marginRight: 2 }}
                            />
                            <MobileDocIconBox>
                              <IcoFile size={16} color={G.teal} />
                            </MobileDocIconBox>
                            <MobileDocBody>
                              <MobileDocName>{doc.name}</MobileDocName>
                              <MobileDocMeta>
                                <DocRef
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    window.open(doc.url?.url, "_blank");
                                  }}
                                >
                                  {doc.documentNo}
                                </DocRef>
                                <span style={{ color: G.slate300 }}>·</span>
                                <span>{doc.formattedDate}</span>
                                {doc.pageCount != null && (
                                  <>
                                    <span style={{ color: G.slate300 }}>·</span>
                                    <span>{doc.pageCount}p</span>
                                  </>
                                )}
                              </MobileDocMeta>
                            </MobileDocBody>
                            {!viewOnly && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 6,
                                }}
                              >
                                {doc?.visibilityType !== "strictMode" && (
                                  <WhatsAppIconBtn
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleOpenWhatsAppModal(doc);
                                    }}
                                  >
                                    <WhatsAppIcon
                                      style={{
                                        fontSize: 16,
                                        color: "#25D366",
                                      }}
                                    />
                                  </WhatsAppIconBtn>
                                )}
                                <DeleteIconBtn
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    openDeleteConfirm(doc);
                                  }}
                                >
                                  <IcoTrash size={13} color={G.red} />
                                </DeleteIconBtn>
                              </div>
                            )}
                          </MobileDocCard>
                        ))}
                      </MobileCardList>
                    </SubFolderBlock>
                  </BundleBlock>
                </BundlesWrap>
              )}
            </Content>
          )}

          {(activeSection === "trial" || activeSection === "private") && (
            <Content>{renderTrialBundlesTable()}</Content>
          )}

          {activeSection === "core" && totalDocs > 0 && (
            <PaginationBar>
              <PaginationInfo>
                Showing{" "}
                <strong>
                  {(currentPage - 1) * itemsPerPage + 1}–
                  {Math.min(currentPage * itemsPerPage, totalDocs)}
                </strong>{" "}
                of <strong>{totalDocs}</strong>
              </PaginationInfo>
              <PaginationRight>
                <PageControls>
                  <PageBtn
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    ← Prev
                  </PageBtn>
                  {Array.from(
                    { length: Math.min(lastPage, 7) },
                    (_, i) => i + 1,
                  ).map((p) => (
                    <PageBtn
                      key={p}
                      $active={p === currentPage}
                      onClick={() => handlePageChange(p)}
                    >
                      {p}
                    </PageBtn>
                  ))}
                  {lastPage > 7 && (
                    <span style={{ color: G.slate400, padding: "0 3px" }}>
                      …
                    </span>
                  )}
                  <PageBtn
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === lastPage}
                  >
                    Next →
                  </PageBtn>
                </PageControls>
                <PerPageSelect
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                >
                  <option value={10}>10 / page</option>
                  <option value={20}>20 / page</option>
                  <option value={50}>50 / page</option>
                </PerPageSelect>
              </PaginationRight>
            </PaginationBar>
          )}

          {viewerMounted && activeDoc && (
            <ViewerPane $phase={viewerPhase}>
              <DocumentViewer
                doc={activeDoc}
                onBack={handleBack}
                openTabs={openTabs}
                onTabClick={handleTabClick}
                onTabClose={handleTabClose}
                id={id}
                setTrigger={() =>
                  fetchDocuments(currentPage, itemsPerPage, activeSource)
                }
                fetchAllBundles={fetchAllBundles}
                activeSection={activeSection}
                trialBundles={trialBundles}
                onCompareToggle={setCompareViewActive}
                onVisibilityChange={handleDocVisibilityUpdated}
                onPrevDoc={
                  prevDocInSeq ? () => handleOpenDoc(prevDocInSeq) : null
                }
                onNextDoc={
                  nextDocInSeq ? () => handleOpenDoc(nextDocInSeq) : null
                }
                hasPrevDoc={Boolean(prevDocInSeq)}
                hasNextDoc={Boolean(nextDocInSeq)}
                onOpenLinkedDoc={handleOpenLinkedDoc}
              />
            </ViewerPane>
          )}
        </ViewportWrap>
      </Main>
      <ViewKeywords view={viewKeywords} setView={setViewKeywords} />
      <DocVisibilityTypeChange
        modal={modalVisibility?.state}
        setModal={() => setModalVisibility({ state: false, metaData: null })}
        rowData={modalVisibility?.metaData}
        id={id}
        setTrigger={() =>
          fetchDocuments(currentPage, itemsPerPage, activeSource)
        }
      />
      {whatsAppModal.state && (
        <WhatsAppDocNotificationModal
          open={whatsAppModal.state}
          onClose={() => setWhatsAppModal({ state: false, doc: null })}
          doc={whatsAppModal.doc}
          onSend={async (payload) => {
            try {
              setLoader({
                state: true,
                message: "Sending WhatsApp notification...",
              });
              let documentUrl = payload.documentUrl;
              let documentFilename = payload.documentName;
              if (payload.redacted) {
                setLoader({
                  state: true,
                  message: "Preparing redacted copy...",
                });
                const blob = await buildRedactedPdf(
                  payload.documentUrl,
                  getRedactions(payload.documentUrl),
                );
                documentUrl = await uploadRedactedPdf(
                  blob,
                  redactedFileName(payload.documentName),
                );
                documentFilename = String(payload.documentName || "document")
                  .replace(/(\.[^.]+)?$/, "_redacted$1");
                setLoader({
                  state: true,
                  message: "Sending WhatsApp notification...",
                });
              }
              const apiPayload = {
                caseId: id,
                whatsappNotificationRecipient: payload.recipients,
                documentId: payload.documentId,
                documentUrl,
                documentFilename,
              };
              const res = await CaseService.sendDocumentByWhatsapp(apiPayload);
              if (res) {
                enqueueSnackbar("WhatsApp notification sent successfully", {
                  variant: "success",
                });
              }
            } catch (error) {
              const errMsg =
                error?.response?.data?.message ||
                error?.message ||
                "Failed to send WhatsApp notification";
              enqueueSnackbar(errMsg, { variant: "error" });
            } finally {
              setLoader({ state: false });
              setWhatsAppModal({ state: false, doc: null });
            }
          }}
        />
      )}
      <AlertDialog isOpen={alertOpen} {...alertData} />

      {showCreateModal && (
        <CreateTrailBundleModal
          open={showCreateModal}
          onClose={() => setShowCreateModal(false)}
          caseId={id}
          onBundleCreated={handleBundleCreated}
          fetchAllBundles={fetchAllBundles}
          coreBundle={true}
        />
      )}
      <CreateSubFolderModal
        open={showCreateSubFolderModal}
        onClose={() => {
          setShowCreateSubFolderModal(false);
          setCreateSubFolderForBundleId(null);
        }}
        onCreated={handleSubFolderCreated}
        bundleName={
          createSubFolderForBundleId
            ? trialBundles.find((b) => b.id === createSubFolderForBundleId)
                ?.name
            : ""
        }
      />

      <CombineBundleModal
        open={showCombineModal}
        onClose={() => setShowCombineModal(false)}
        bundles={trialBundles}
        onCombined={handleCombineBundle}
        ownerId={userObject?.id}
      />

      {moveDocState && (
        <MoveDocumentModal
          open={!!moveDocState}
          onClose={() => setMoveDocState(null)}
          bundles={trialBundles}
          assignment={moveDocState.assignment}
          sourceBundleId={moveDocState.sourceBundleId}
          sourceSfCode={moveDocState.sourceSfCode}
          onMoved={handleMoveDocument}
          strictPrivate={activeSection === "private"}
          ownerId={userObject?.id}
        />
      )}
      {uploadDocState && (
        <UploadDocumentsModal
          open={!!uploadDocState}
          onClose={() => setUploadDocState(null)}
          caseId={id}
          bundle={uploadDocState.bundle}
          subFolder={uploadDocState.subFolder}
          onUploaded={handleUploadDocuments}
          ownerId={userObject?.id}
        />
      )}
    </Shell>
  );
};

export default CoreBundleView;
